<template>
  <div class="d-flex flex-column align-items-center fade-in">
    <div v-if="!processingPayment" class="payment-container">
      <content-header :title="`${requirePayment ?  'Summary & Payment' : 'Summary'}`" :sub-title="subTitle" class="w-100 mxw-lg px-10"/>
      <div class="d-flex justify-content-center w-100 mb--10" v-if="isLoaded">
        <el-row class="payment-container" :gutter="20">
          <el-col class="mt-10" v-bind="resCol">
            <content-body-card>
              <content-header title="Registration Summary" class="fs-09 mt--10"/>
              <div class="mb--05">
                <div v-if="summary.length">
                  <div class="mt-10" v-for="(rego, idx) in summary" :key="idx">
                    <div v-if="(rego.productType === 'indv' || rego.productType === 'indv-to-team') && !rego.isBulk">
                      <el-card class="registration-summary-card" shadow="never">
                        <div slot="header" class="card-header-content">
                          <h4 class="registration-title">{{ rego.playerName }}</h4>
                        </div>
                        <div class="registration-details">
                          <div class="detail-item">
                            <span class="detail-label">Name:</span>
                            <span class="detail-value">{{ rego | parseEntityName }}</span>
                          </div>
                          <div class="detail-item">
                            <span class="detail-label">Registration Type:</span>
                            <span class="detail-value">{{ rego.registrationType | cap }}</span>
                          </div>
                          <div class="detail-item">
                            <span class="detail-label">Product Type:</span>
                            <span class="detail-value">{{ rego.productType | parseProductType }}</span>
                          </div>
                          <div class="detail-item">
                            <span class="detail-label">Member Type:</span>
                            <span class="detail-value">{{ rego.memberType | cap }}</span>
                          </div>
                          <div v-if="rego.tags && rego.tags.length > 0" class="detail-item">
                            <span class="detail-label">Tags:</span>
                            <span class="detail-value">{{ rego.tags | joinTag }}</span>
                          </div>
                        </div>
                      </el-card>
                    </div>
                    <div v-else-if="rego.productType === 'family'">
                      <el-card class="registration-summary-card" shadow="never">
                        <div slot="header" class="card-header-content">
                          <h4 class="registration-title">{{ rego | parseEntityName }}</h4>
                        </div>
                        <div class="registration-details">
                          <div class="detail-item">
                            <span class="detail-label">Registration Type:</span>
                            <span class="detail-value">{{ rego.registrationType | cap }}</span>
                          </div>
                          <div class="detail-item">
                            <span class="detail-label">Product Type:</span>
                            <span class="detail-value">{{ rego.productType | parseProductType }}</span>
                          </div>
                          <div v-if="rego.tags && rego.tags.length > 0" class="detail-item">
                            <span class="detail-label">Tags:</span>
                            <span class="detail-value">{{ rego.tags | joinTag }}</span>
                          </div>
                          <div class="family-members-section">
                            <h5 class="members-section-title">Family Members</h5>
                            <el-table
                              :data="rego.memberDetails"
                              size="small"
                              style="width: 100%">
                              <el-table-column
                                prop="playerName"
                                label="Member"
                                width="180">
                              </el-table-column>
                              <el-table-column
                                prop="memberType"
                                label="Member Type"
                                width="180">
                                <template v-slot="scope">
                                  {{ scope.row.memberType | cap }}
                                </template>
                              </el-table-column>
                            </el-table>
                          </div>
                        </div>
                      </el-card>
                    </div>
                    <div v-else-if="rego.isBulk">
                      <el-card class="registration-summary-card" shadow="never">
                        <div slot="header" class="card-header-content">
                          <h4 class="registration-title">{{ rego | parseEntityName }}</h4>
                        </div>
                        <div class="registration-details">
                          <div class="detail-item">
                            <span class="detail-label">Registration Type:</span>
                            <span class="detail-value">{{ rego.registrationType | cap }}</span>
                          </div>
                          <div class="detail-item">
                            <span class="detail-label">Product Type:</span>
                            <span class="detail-value">{{ rego.productType | parseProductType }}</span>
                          </div>
                          <div class="detail-item">
                            <span class="detail-label">Member Type:</span>
                            <span class="detail-value">{{ rego.memberType | cap }}</span>
                          </div>
                          <div v-if="rego.tags && rego.tags.length > 0" class="detail-item">
                            <span class="detail-label">Tags:</span>
                            <span class="detail-value">{{ rego.tags | joinTag }}</span>
                          </div>
                          <div class="bulk-members-section">
                            <h5 class="members-section-title">Registering Members</h5>
                            <el-table
                              max-height="250"
                              :data="memberDetails(rego)"
                              size="small"
                              style="width: 100%"
                              border>
                              <el-table-column prop="profile.firstName" label="First Name"></el-table-column>
                              <el-table-column prop="profile.lastName" label="Last Name"></el-table-column>
                              <el-table-column prop="profile.dob" label="DOB"></el-table-column>
                              <el-table-column prop="profile.gender" label="Gender"></el-table-column>
                              <el-table-column label="" width="70">
                                <template v-slot="scope">
                                  <div class="action-cell">
                                    <el-button
                                      type="danger"
                                      size="mini"
                                      @click="removeMember(rego, scope.row._id)"
                                      class="delete-button">
                                      <i class="el-icon-delete"></i>
                                    </el-button>
                                  </div>
                                </template>
                              </el-table-column>
                            </el-table>
                          </div>
                        </div>
                      </el-card>
                    </div>
                    <div v-else>
                      <el-card class="registration-summary-card" shadow="never">
                        <div slot="header" class="card-header-content">
                          <h4 class="registration-title">{{ rego.teamName }}</h4>
                        </div>
                        <div class="registration-details">
                          <div class="detail-item">
                            <span class="detail-label">Age Range:</span>
                            <span class="detail-value">{{ rego.ageRange }}</span>
                          </div>
                          <div class="detail-item">
                            <span class="detail-label">Event:</span>
                            <span class="detail-value">{{ rego.eventName }}</span>
                          </div>
                          <div v-if="rego.tags && rego.tags.length > 0" class="detail-item">
                            <span class="detail-label">Tags:</span>
                            <span class="detail-value">{{ rego.tags | joinTag }}</span>
                          </div>
                        </div>
                      </el-card>
                    </div>
                    <div :class="{'pay-later-wrapper': rego.allowPayLater, 'pay-later-selected': summary[idx].payLater}">
    <div class="pay-later-checkbox">
      <el-checkbox v-if="rego.allowPayLater" v-model="summary[idx].payLater" @change="updatePayLater(rego, idx, $event)">
        Pay Later
        <el-tooltip content="Select to make offline payment to your organisation" placement="top" effect="light">
          <i class="el-icon-info"></i>
        </el-tooltip>
      </el-checkbox>
    </div>
    <div class="card-container">
      <el-card body-style="padding: 0;" class="item-card" shadow="never">
        <div slot="header">
          <el-row type="flex" justify="space-between">
            <el-col :span="13" :xs="24">
              <span class="header-label">Product</span>
            </el-col>
            <el-col v-if="requirePayment" :span="4" :xs="0">
              <span class="header-label">Price</span>
            </el-col>
            <el-col :span="4" :xs="0">
              <span class="header-label">QTY</span>
            </el-col>
            <el-col v-if="requirePayment" :span="4" :xs="0" class="text-right">
              <span class="header-label">Cost</span>
            </el-col>
          </el-row>
        </div>
        <div class="card-body-container">
          <div class="card-body" v-for="(product, index) in rego.products" :key="index">
            <!-- Desktop view -->
            <el-row type="flex" justify="space-between" class="mb-10 align-items-center desktop-view">
              <el-col :span="13">
                <span>{{ product.name }}</span>
              </el-col>
              <el-col v-if="requirePayment" :span="4">
                <span v-if="product.price && !isNaN(product.price)">{{ product.price | parsePrice }}</span>
              </el-col>
              <el-col :span="4">
                <el-input-number class="qty-input" :controls="false" v-model="product.qty" :disabled="isQtyDisabled(product)"/>
              </el-col>
              <el-col v-if="requirePayment" :span="4" class="text-right">
                <div class="d-flex flex-column text-right">
                  <span>
                    {{ product.total | parsePrice }}
                  </span>
                  <div class="product-actions" v-if="product.isSaleableItem">
                    <el-button title="update" type="text"
                               @click="updateQty(idx, product, index)"
                               :disabled="noQtyChanged(idx, product, index)">
                      <i class="el-icon-check"></i>
                    </el-button>
                    <el-button title="delete" type="text"
                               icon="el-icon-delete"
                               @click="deleteSaleableItem(idx, product, index)"
                               :disabled="!noQtyChanged(idx, product, index)">
                    </el-button>
                  </div>
                  <el-button v-if="get(product, 'feeRequired') !== undefined && get(product, 'feeRequired') === false"
                             title="update" type="text" @click="updateCstmFeeQty(idx, product)">
                    <i class="el-icon-check"></i>
                  </el-button>
                </div>
              </el-col>
            </el-row>

            <!-- Mobile view -->
            <div class="mobile-view">
              <div class="product-header mb-10">{{ product.name }}</div>
              <div class="product-details">
                <div class="detail-row">
                  <span class="detail-label">Price:</span>
                  <span class="detail-value" v-if="product.price && !isNaN(product.price)">
                    {{ product.price | parsePrice }}
                  </span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">QTY:</span>
                  <el-qty-input
                    v-model="product.qty"
                    :disabled="!product.isSaleableItem"
                    class="qty-input"
                  />
                </div>
                <div class="detail-row">
                  <span class="detail-label">Subtotal:</span>
                  <span class="detail-value">{{ product.total | parsePrice }}</span>
                </div>
              </div>
              <div class="product-actions" v-if="product.isSaleableItem">
                <el-button title="update" type="text"
                           @click="updateQty(idx, product, index)"
                           :disabled="noQtyChanged(idx, product, index)">
                  <i class="el-icon-check"></i>
                </el-button>
                <el-button title="delete" type="text"
                           icon="el-icon-delete"
                           @click="deleteSaleableItem(idx, product, index)"
                           :disabled="!noQtyChanged(idx, product, index)">
                </el-button>
              </div>
              <el-button v-if="get(product, 'feeRequired') !== undefined && get(product, 'feeRequired') === false"
                         title="update" type="text" @click="updateCstmFeeQty(idx, product)">
                <i class="el-icon-check"></i>
              </el-button>
            </div>

            <el-divider></el-divider>

            <!-- Sub Products -->
            <el-row v-if="get(product, 'subProducts', []).length" class="sub-products-list">
              <el-col :span="24">
                <div class="sub-products-title">Sub Products:</div>
                <ul class="sub-products-names inline-list">
                  <li v-for="(subProduct, subIndex) in product.subProducts" :key="subIndex">
                    {{ subProduct.name }}
                  </li>
                </ul>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-card>
    </div>
  </div>
                    <div class="mb-15 mt-15" v-if="rego && rego.payAfter">
                    <h3 class="f-light mt--05">Pay After Details</h3>
                    <small> Minimum Payment: <b>{{ rego.minPrice | parsePrice }}</b> </small>
                    <el-row class="d-flex align-items-center mt-15" v-if="rego && rego.total">
                      <el-col :span="19" :md="12">
                        <el-price-input
                          :key="`${rego._id}-${rego.total}`"
                          v-model="rego.payToday"
                          :min="rego.minPrice"
                          :max="rego.total"
                        />
                      </el-col>
                      <h1 class="price-divider ml-05"> / </h1>
                      <el-col :span="5" :md="2" class="ml-05">
                        <h3>{{ rego.total | parsePrice }}</h3>

                      </el-col>
                    </el-row>
                    </div>
                  <div v-if="rego && rego.total > 0" class="d-flex justify-content-end mt-05">
                      <span v-if="voucherAvailable(rego)" class="f-light ml-10 text-underline pointer" @click="[6,9].includes(nationalId) ? showVICActiveKidsModal(idx) : showActiveKidsModal(idx)">+ Add Active Kids Voucher</span>
                      <span v-if="additionalVoucherAvailable(rego, idx)" class="f-light ml-10 text-underline pointer" @click="showAdditionalActiveKidsModal(idx)">+ Add 2nd Active Kids Voucher</span>
                  </div>
                    <!-- <div class="mb-15 mt-15" >
                    <h3 class="f-light mt--05">{{ rego.donation.label }}</h3>
                    <el-row class="d-flex align-items-center mt-15">
                      <el-col :span="19" :md="12">
                        <el-price-input v-model="donate"  />
                      </el-col>
                    </el-row>
                  </div> -->

                    <!-- <div class="redeem" v-if="rego.discountVoucher">
                      <div class="mt-10 d-flex justify-content-between">
                        <el-input v-model="rego.discountVoucher.code" :disabled="rego.discountVoucher && rego.discountVoucher.redeemed" class="discount-code" placeholder="Enter your discount code" ></el-input>
                        <el-button type="primary" v-if="!rego.discountVoucher || !rego.discountVoucher.redeemed" class="ml-10" @click="redeem(idx)">Redeem Code</el-button>
                        <el-button type="primary" v-else class="ml-10" @click="cancelRedeemed(idx)">Cancel Code</el-button>
                      </div>
                      <span v-if="rego.discountVoucher && rego.discountVoucher.error" class="font-light text-danger">{{ rego.discountVoucher.error }}</span>
                    </div> -->
                    <div class="registration-actions">
                      <el-button type="primary" class="action-btn remove-btn" @click="remove(idx, rego.productType)">Remove</el-button>
                      <el-button type="primary" class="action-btn edit-btn" @click="edit(idx, rego.productType)">Edit</el-button>
                    </div>
                    <!-- <el-divider class="mt-10" /> -->
                  </div>
                </div>

                <!-- <div class="d-flex justify-content-between fs-07" v-if="![4, 7].includes(national) && feePercentage && !payment.directSaleableItems.length">
                  <h3>*A ~{{ feePercentage }}% transaction fee will apply to all online payments.</h3>
                </div>
                <div v-if="!payment.directSaleableItems.length" class="d-flex justify-content-between fs-07">
                  <h2>Discount Total:</h2>
                  <h2>{{ discountTotal | parsePrice }}</h2>
                </div>
                <div v-if="!payment.directSaleableItems.length" class="d-flex justify-content-between fs-09">
                  <h2>Cart Total:</h2>
                  <h2>{{totalWithSaleableItems | parsePrice}}</h2>
                </div> -->
              </div>
            </content-body-card>
            <content-body-card class="mt-10" v-if="payment.directSaleableItems.length">
              <content-header title="Store Summary" class="fs-09 mt--20" />
              <div class="mb--05">
                <!-- div for saleableItems -->
                <div class="mt-10">
                  <el-card class="store-summary-card item-card" shadow="never">
                    <div slot="header" class="store-summary__header store-summary__grid">
                      <span>Product</span>
                      <span>Price</span>
                      <span>QTY</span>
                      <span class="text-right">Cost</span>
                    </div>
                    <div class="store-summary__body">
                      <div
                        v-for="(item, idx) in payment.directSaleableItems"
                        :key="idx"
                        class="store-summary__row store-summary__grid"
                      >
                        <div class="store-summary__product">
                          <div class="store-summary__name">{{ item.name }}</div>
                        </div>
                        <div class="store-summary__price">
                          <span class="store-summary__field-label">Price</span>
                          <span class="store-summary__value" v-if="item.price && !isNaN(item.price)">
                            {{ item.price | parsePrice }}
                          </span>
                        </div>
                        <div class="store-summary__qty">
                          <span class="store-summary__field-label">Qty</span>
                          <el-qty-input v-model="item.qty" />
                        </div>
                        <div class="store-summary__total">
                          <div class="store-summary__total-line">
                            <span class="store-summary__field-label">Subtotal</span>
                            <span class="store-summary__value">{{ item.price * item.qty | parsePrice }}</span>
                          </div>
                          <div class="store-summary__row-actions">
                            <el-button title="update" type="text" @click="updateDirectQty(item, idx)">
                              <i class="el-icon-check"></i>
                            </el-button>
                            <el-button
                              title="delete"
                              type="text"
                              icon="el-icon-delete"
                              @click="deleteDirectSaleableItem(item, idx)"
                            ></el-button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-card>
                  <el-divider class="mt-10" />
                </div>

                <div class="d-flex justify-content-between fs-07" v-if="![4, 7].includes(national) && (feePercentage || (fixedTechFee && fixedTechFee.enabled))">
                  <h3 v-if="fixedTechFee && fixedTechFee.enabled">
                    *A ~{{ feePercentage }}% transaction fee and a technology fee per registration will apply to online payments.
                  </h3>
                  <h3 v-else>
                    *A ~{{ feePercentage }}% transaction fee will apply to all online payments.
                  </h3>
                  <!-- <h2>Transaction Fee</h2>
                  <h2>${{transactionFee | parsePrice}}</h2> -->
                </div>
                <!-- <div class="d-flex justify-content-between fs-07">
                  <h2>Discount Total:</h2>
                  <h2>{{ discountTotal | parsePrice }}</h2>
                </div> -->
                <div class="d-flex justify-content-center mt-10">
                  <!-- <el-button type="primary" class="bottomBtn" @click="edit" disabled>Edit</el-button> -->
                  <!-- <el-button type="primary" class="btn-highlight bottomBtn" @click="remove(idx, rego.productType)">Remove</el-button> -->
                </div>
                <el-divider class="mt-10" />
                <div class="mb-15 mt-15" v-if="rego && rego.payAfter">
                <h3 class="f-light mt--05">Pay After Details</h3>
                <small> Minimum Payment: <b>{{ rego.minPrice | parsePrice }}</b> </small>
                <el-row class="d-flex align-items-center mt-15" v-if="rego && rego.total">
                  <el-col :span="19" :md="12">
                    <el-price-input
                      :key="`${rego._id}-${rego.total}`"
                      v-model="rego.payToday"
                      :min="rego.minPrice"
                      :max="rego.total"
                    />
                  </el-col>
                  <h1 class="price-divider ml-05"> / </h1>
                  <el-col :span="5" :md="2" class="ml-05">
                    <h3>{{ rego.total | parsePrice }}</h3>
                  </el-col>
                </el-row>
                <div class="mb-15 mt-15" v-if="rego && rego.payAfter">
                <h3 class="f-light mt--05">Pay After Details</h3>
                <small> Minimum Payment: <b>{{ rego.minPrice | parsePrice }}</b> </small>
                <el-row class="d-flex align-items-center mt-15" v-if="rego && rego.total">
                  <el-col :span="19" :md="12">
                    <el-price-input
                      :key="`${rego._id}-${rego.total}`"
                      v-model="rego.payToday"
                      :min="rego.minPrice"
                      :max="rego.total"
                    />
                  </el-col>
                  <h1 class="price-divider ml-05"> / </h1>
                  <el-col :span="5" :md="2" class="ml-05">
                    <h3>{{ rego.total | parsePrice }}</h3>
                  </el-col>
                </el-row>
              </div>
              </div>
                <!-- <div class="mb-15 mt-15" >
                <h3 class="f-light mt--05">{{ rego.donation.label }}</h3>
                <el-row class="d-flex align-items-center mt-15">
                  <el-col :span="19" :md="12">
                    <el-price-input v-model="donate"  />
                  </el-col>
                </el-row>
                </div> -->

                <!-- <div class="redeem" v-if="rego.discountVoucher">
                  <div class="mt-10 d-flex justify-content-between">
                    <el-input v-model="rego.discountVoucher.code" :disabled="rego.discountVoucher && rego.discountVoucher.redeemed" class="discount-code" placeholder="Enter your discount code" ></el-input>
                    <el-button type="primary" v-if="!rego.discountVoucher || !rego.discountVoucher.redeemed" class="ml-10" @click="redeem(idx)">Redeem Code</el-button>
                    <el-button type="primary" v-else class="ml-10" @click="cancelRedeemed(idx)">Cancel Code</el-button>
                  </div>
                  <span v-if="rego.discountVoucher && rego.discountVoucher.error" class="font-light text-danger">{{ rego.discountVoucher.error }}</span>
                </div> -->
                <div v-if="rego && rego.total > 0" class="d-flex justify-content-end mt-05">
                  <!-- <span class="f-light text-underline pointer">+ Add Discount</span> -->
                  <span v-if="voucherAvailable(rego)" class="f-light ml-10 text-underline pointer" @click="[6,9].includes(nationalId) ? showVICActiveKidsModal(idx) : showActiveKidsModal(idx)">+ Add Active Kids Voucher</span>
                </div>
                <!-- <div class="d-flex justify-content-center mt-10">
                  <el-button type="primary" class="bottomBtn" @click="edit" disabled>Edit</el-button>
                  <el-button type="primary" class="btn-highlight bottomBtn" @click="remove(idx, rego.productType)">Remove</el-button>
                </div> -->
              </div>
            </content-body-card>
            <content-body-card v-if="requirePayment || cartTotal === 0 && regoDiscounts.length > 0" class="mt-10">
              <div class="d-flex justify-content-between fs-07" v-if="![4, 7].includes(national) && feePercentage">
                <!-- <h3>*A {{ feePercentage }}% transaction fee will apply to all online payments.</h3> -->
                <!-- <h2>Transaction Fee</h2>
                <h2>${{transactionFee | parsePrice}}</h2> -->
              </div>
              <!-- Checkout Total Discount -->
              <div v-for="discount of regoDiscounts" :key="discount._id">
                <div class="mt-10 d-flex justify-content-between">
                  <el-input size="small" v-model="discount.discountVoucher.code" :disabled="discount.discountVoucher && discount.discountVoucher.redeemed" class="discount-code" placeholder="Enter your checkout total discount code" ></el-input>
                  <el-button
                    type="primary"
                    size="small"
                    v-if="!discount.discountVoucher || !discount.discountVoucher.redeemed"
                    class="ml-10"
                    :loading="redeemLoading[discount._id]"
                    @click="initRedeem(discount._id)"
                  >Redeem Code</el-button>                  <el-button type="primary" size="small" v-else class="ml-10" @click="cancelRedeemedNew(discount.discountVoucher)">Cancel Code</el-button>
                  <el-button type="primary" size="small" :disabled="discount.discountVoucher.redeemed" v-if="regoDiscounts.length > 1" class="ml-10" @click="removeAdditionalVoucher(discount._id)">Remove Code</el-button>
                </div>
                <span v-if="discount.discountVoucher && discount.discountVoucher.error" class="font-light text-danger">{{ discount.discountVoucher.error }}</span>
              </div>
              <div class="d-flex justify-content-end mt-05">
                <!-- <span class="f-light text-underline pointer">+ Add Discount</span> -->
                <span class="f-light ml-10 text-underline pointer" @click="newDiscountVoucher">+ Apply Additional Voucher</span>
              </div>

              <!-- <div class="d-flex justify-content-between fs-07">
                <h2>Discount Total:</h2>
                <h2>{{ discountTotal | parsePrice }}</h2>
              </div> -->
              <!-- <div class="d-flex justify-content-center mt-10"> -->
              <div class="d-flex justify-content-center mt-10">
                <!-- <el-button type="primary" class="bottomBtn" @click="edit" disabled>Edit</el-button> -->
                <!-- <el-button type="primary" class="btn-highlight bottomBtn" @click="remove(idx, rego.productType)">Remove</el-button> -->
              </div>
              <el-divider class="mt-10" />
              <!-- </div> -->
              <div class="d-flex justify-content-between fs-07" v-if="![4, 7].includes(national) && (feePercentage || (fixedTechFee && fixedTechFee.enabled))">
                <h3 v-if="fixedTechFee && fixedTechFee.enabled">
                  *A {{ feePercentage }}% transaction fee and a technology fee per registration will apply to online payments.
                </h3>
                <h3 v-else>
                  *A {{ feePercentage }}% transaction fee will apply to all online payments.
                </h3>
                <!-- <h2>Transaction Fee</h2>
                <h2>${{transactionFee | parsePrice}}</h2> -->
              </div>
              <div class="d-flex justify-content-between fs-07">
                <h2>Discount Total:</h2>
                <h2>{{ discountTotal | parsePrice }}</h2>
              </div>
              <div class="d-flex justify-content-between fs-09">
                <h2>Cart Total:</h2>
                <h2>{{totalWithSaleableItems | parsePrice}}</h2>
              </div>
            </content-body-card>
        </el-col>
        <el-col class="mt-10" :xs="24" :sm="24" :md="12" :lg="12">
            <content-body-card v-if="requirePayment">

              <content-header :title="paymentTitle" class="fs-09 mt--10"/>
              <el-row v-if="nationalId === 1 || nationalId === 18 || nationalId === 15">
                <div class="vendor-payment text-center mb-10" :class="{ single: !canShowApplePay && isNotFirefox }">
                  <GooglePayButton
                    id="google-pay-btn"
                    :options="options"
                    v-if="isNotFirefox"
                    @payed="payGoogle($event)"
                  />
                  <div class="apple-button">
                    <!-- disabling for now -->
                    <apple-pay-button v-if="canShowApplePay" buttonstyle="black" type="plain" lang="en" @click.stop="startApplePaySession"></apple-pay-button>
                  </div>
                </div>
              </el-row>
              <el-divider class="mt-10 mb-20"><span class="mx-2" v-if="canShowApplePay || isNotFirefox">OR</span></el-divider>
              <el-form ref="form" :model="payment" :rules="rules">
                <div class="mb-10">
                  <h3 class="f-light mt--05">Credit Card Details</h3>
                  <small v-if="nationalId === 18"> International Cards are not accepted </small>
                  <small v-else> International American Express are not accepted </small>
                  <credit-card v-model="payment.card" ref="card" :width="300" data-dd-privacy="hidden"/>
                  <el-divider />
                  <div class="d-flex align-items-center " style="height: 30px; margin-bottom: 20px;">
                  <h3 class="f-light mr-10">
                    Billing Address
                  </h3>
                    <el-button
                      class="py-0 fs-09 op-7 manualAddressBtn"
                      type="text"
                      @click="manualAddress"
                    >
                      {{
                        payment.billingAddress.isManual
                          ? "Search Address"
                          : "Enter Address Manually"
                      }}
                    </el-button>

                </div>
                <div id="auto-fill" class="mt--10" v-if="fillingAddress">
                    <span type="text" class=" auto-fill text-underline c-highlight fs-09 pointer" @click="fillAddress(fillingAddress)">Fill address with {{ fillingAddress.formatted }}</span>
                  </div>
                  <el-row :gutter="20">
            <el-form-item prop="billingAddress.formatted">
              <el-input
                v-if="payment.billingAddress.isManual"
                class="mt-05"
                v-model="payment.billingAddress.formatted"
                disabled
              />
              <google-auto-complete
                v-else
                class="auto-complete mt-05"
                name="address"
                id="map"
                :key="1"
                ref="address"
                @change="checkAddress($event)"
                v-model="payment.billingAddress.formatted"
                placeholder="Enter an Address"
              >
              </google-auto-complete>
            </el-form-item>

                  <el-col :span="24" :md="12" class="mt-10" v-if="payment.billingAddress.isManual">
                      <el-input-title required>Address Line 1</el-input-title>
                      <el-form-item prop="billingAddress.addressLine1">
                        <el-input class="mt-05" v-model="payment.billingAddress.addressLine1" placeholder="Type here..." />
                      </el-form-item>
                    </el-col>
                    <el-col :span="24" :md="12" class="mt-10" v-if="payment.billingAddress.isManual">
                      <el-input-title>Address Line 2</el-input-title>
                      <el-form-item prop="billingAddress.addressLine2">
                        <el-input class="mt-05" v-model="payment.billingAddress.addressLine2" placeholder="Type here..." />
                      </el-form-item>
                    </el-col>
                    <el-col :span="24" :md="12" class="mt-10" v-if="payment.billingAddress.isManual">
                      <el-input-title required>City/Suburb</el-input-title >
                      <el-form-item prop="billingAddress.suburb">
                        <el-input class="mt-05" v-model="payment.billingAddress.suburb" placeholder="Type here..." />
                      </el-form-item>
                    </el-col>
                    <el-col :span="24" :md="12" class="mt-10" v-if="payment.billingAddress.isManual">
                      <el-input-title >State</el-input-title>
                      <el-form-item prop="billingAddress.state">
                        <el-input class="mt-05" v-model="payment.billingAddress.state" placeholder="Type here..." />
                      </el-form-item>
                    </el-col>
                    <el-col :span="24" :md="12" class="mt-10" v-if="payment.billingAddress.isManual">
                      <el-input-title required>Postcode</el-input-title>
                      <el-form-item prop="billingAddress.postcode">
                        <el-input class="mt-05" v-model="payment.billingAddress.postcode" placeholder="Type here..." />
                      </el-form-item>
                    </el-col>
                    <el-col :span="24" :md="12" class="mt-10" v-if="payment.billingAddress.isManual">
                      <el-input-title required>Country</el-input-title>
                      <el-form-item prop="billingAddress.country">
                        <el-autocomplete
                          class="mt-05 w-100"
                          v-model="payment.billingAddress.country"
                          :fetch-suggestions="searchCountry"
                          placeholder="Select"
                        ></el-autocomplete>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </el-form>
              <el-col :span="24" class="d-flex justify-content-center mt-20">
            </el-col>
          </content-body-card>
          </el-col>
          <el-col :span="24" class="d-flex justify-content-center">
            <el-button type="primary" class="btn-highlight payBtn mt-10" @click.prevent="pay" :disabled="isPayDisabled">{{paymentButtonText}}</el-button>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-dialog title="Active Kids Voucher" :visible.sync="activeKidsModalVisible" :before-close="handleActiveKidsClose" :close-on-click-modal="false">
      <div class="d-flex flex-column w-100">
        <el-form ref="activeKids" :model="activeKids" :rules="activeKidsRules">
          <el-row>
            <el-col :span="24">
              <el-input-title required>Voucher Number</el-input-title>
              <el-form-item prop="voucherNumber">
                <el-input class="mt-05" v-model="activeKids.voucherNumber" placeholder="Type here..." />
              </el-form-item>
            </el-col>
            <!-- <el-col :span="24">
              <el-input-title required>PIN (Date of Birth - DDMM)</el-input-title>
              <el-form-item prop="pin">
                <el-input class="mt-05" v-model="activeKids.pin" placeholder="Type here..." />
              </el-form-item>
            </el-col> -->
          </el-row>
          <div class="filter-btns d-flex flex-row justify-content-center">
            <el-button
            type="primary"
            class="w-25 bg-highlight bd-0"
            @click="addActiveKidsVoucher"
            >Add</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>

    <el-dialog title="Active Kids Voucher (VIC)" :visible.sync="victoriaActiveKidsVisible" :before-close="handleVictoriaActiveKidsClode" :close-on-click-modal="false">
      <div class="d-flex flex-column w-100">
        <el-form ref="victoriaActiveKids" :model="victoriaActiveKids" :rules="victoriaActiveKidsRules">
          <el-row>
            <el-col :span="24">
              <el-input-title required>Voucher Number (XX-XXXXXXX-XXXX)</el-input-title>
              <el-form-item prop="voucherNumber">
                <el-input class="mt-05" v-model="victoriaActiveKids.voucherNumber" placeholder="Type here..." />
              </el-form-item>
            </el-col>
          </el-row>
          <div class="filter-btns d-flex flex-row justify-content-center">
            <el-button type="primary" class="w-25 bg-highlight bd-0" @click="addVICActiveKidsVoucher">Add</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>

      <el-dialog
      title="Add Additional Active Kids Voucher"
      :visible.sync="additionalActiveKidsModalVisible"
      width="30%"
    >
      <el-form ref="additionalActiveKids" :model="additionalActiveKids">
        <el-row>
          <el-col :span="24">
            <el-input-title required>Voucher Number</el-input-title>
            <el-form-item prop="voucherNumber">
              <el-input class="mt-05" v-model="additionalActiveKids.voucherNumber" placeholder="Type here..." />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="additionalActiveKidsModalVisible = false">Cancel</el-button>
        <el-button type="primary" @click="addAdditionalActiveKidsVoucher">Add Voucher</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="Select Registrations for Discount Code"
      :before-close="handleRegoSelectionClose"
      :visible.sync="productsDialogVisible"
      :close-on-click-modal="false"
      width="70%"
      class="discount-selection-dialog">
      <div class="dialog-content w-100">
        <div class="selection-header mb-4">
          <el-alert
            type="info"
            :closable="false"
            v-if="availableProducts.length > 0"
            class="selection-alert">
            <div class="alert-content">
              <i class="el-icon-info"></i>
              <span class="ml-2">Selected {{ selectedProductCount }} of {{ availableProducts.length }} available registrations</span>
            </div>
          </el-alert>
          <el-alert
            type="error"
            :closable="false"
            v-else
            class="selection-alert">
            <div class="alert-content">
              <i class="el-icon-warning"></i>
              <span class="ml-2">No eligible registrations found for this discount code.</span>
            </div>
          </el-alert>
        </div>

        <div v-if="availableProducts.length > 0" class="registrations-list">
          <div
            v-for="rego in availableProducts"
            :key="getRegoUniqueKey(rego)"
            class="registration-card mb-3">

            <!-- Individual Registration Card -->
            <el-card v-if="rego.productType !== 'family'" shadow="hover" class="rego-card">
              <div class="card-header">
                <div class="registration-info">
                  <h4 class="entity-name">{{ rego | parseEntityName }}</h4>
                  <div class="registration-meta">
                    <el-tag size="small" type="info">{{ rego.entityType | cap }}</el-tag>
                    <el-tag size="small" class="ml-1">{{ rego.productType | parseProductType }}</el-tag>
                    <el-tag v-if="rego.productType === 'indv-to-team' && rego.team" size="small" type="warning" class="ml-1">
                      <i class="el-icon-user-solid"></i> {{ rego.team.name }}
                    </el-tag>
                  </div>
                </div>
              </div>

              <div class="card-body">
                <div class="member-details">
                  <div class="member-name">
                    <i class="el-icon-user"></i>
                    <span class="ml-1">{{ rego.profile.firstName }} {{ rego.profile.lastName }}</span>
                  </div>
                  <div class="member-type">
                    <span class="label">Type:</span>
                    <span class="value">{{ rego.memberType | cap }}</span>
                  </div>
                </div>
              </div>

              <div class="card-footer">
                <el-checkbox
                  v-model="productsForDiscount[getRegoUniqueKey(rego)]"
                  :disabled="checkDiscountLimit(rego)"
                  @change="regoSelected($event, rego)"
                  class="selection-checkbox">
                  <span class="checkbox-label">Apply discount to this registration</span>
                </el-checkbox>
              </div>
            </el-card>

            <!-- Family Registration Card -->
            <el-card v-else shadow="hover" class="rego-card family-card">
              <div class="card-header">
                <div class="registration-info">
                  <h4 class="entity-name">{{ rego | parseEntityName }}</h4>
                  <div class="registration-meta">
                    <el-tag size="small" type="info">{{ rego.registrationType | cap }}</el-tag>
                    <el-tag size="small" class="ml-1">{{ rego.productType | parseProductType }}</el-tag>
                    <el-tag v-if="rego.tags && rego.tags.length > 0" size="small" type="success" class="ml-1">
                      {{ rego.tags | joinTag }}
                    </el-tag>
                  </div>
                </div>
              </div>

              <div class="card-body">
                <div class="family-members">
                  <h5 class="members-title">
                    <i class="el-icon-users"></i>
                    <span class="ml-1">Family Members</span>
                  </h5>
                  <el-table
                    :data="getFamilyMemberDetails(rego)"
                    size="small"
                    class="members-table">
                    <el-table-column prop="playerName" label="Member" width="200"></el-table-column>
                    <el-table-column prop="memberType" label="Type" width="150">
                      <template v-slot="scope">
                        <el-tag size="mini">{{ scope.row.memberType | cap }}</el-tag>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>

              <div class="card-footer">
                <el-checkbox
                  v-model="productsForDiscount[getRegoUniqueKey(rego)]"
                  :disabled="checkDiscountLimit(rego)"
                  @change="regoSelected($event, rego)"
                  class="selection-checkbox">
                  <span class="checkbox-label">Apply discount to this family registration</span>
                </el-checkbox>
              </div>
            </el-card>
          </div>
        </div>

        <div v-if="availableProducts.length > 0" class="dialog-actions">
          <el-button @click="handleRegoSelectionClose" size="medium">Cancel</el-button>
          <el-button
            type="primary"
            @click="applyDiscountToSelectedEntity"
            :disabled="selectedProductCount === 0"
            size="medium">
            Apply Discount ({{ selectedProductCount }})
          </el-button>
        </div>
      </div>
    </el-dialog>
    <!-- another dialog to ask if they want to donation the money -->
    <success v-if="processingPayment"
    :payment="payment"
    :token1="token1"
    :token2="token2"
    :cartTotal="cartTotal"
    :indvCartTotal="currentIndvCartTotal"
    :total="total"
    :indvTotal="indvTotal"
    :payAfter="payAfter"
    :payTodayTotal="payTodayTotal"
    :indvPayTodayTotal="indvPayTodayTotal"
    :totalWithSaleableItems="totalWithSaleableItems"
    :totalSaleableItemsWithFee="totalSaleableItemsWithFee"
    @goToPayment="goToPayment"
    />
  </div>
</template>

<script>
/* eslint-disable object-shorthand */
/* eslint-disable object-shorthand */

import _ from 'lodash';
import moment from 'moment';
import { VueMaskDirective } from 'v-mask';
import { calculateMemberAge } from '@/utils/helpers';
import { errormsg, countries, productTypes } from '@/utils/constants';
import { mapGetters } from 'vuex';
import GooglePayButton from 'vue-google-pay';
import { datadogRum } from '@datadog/browser-rum';
import Success from './Success.vue';

const defaultRequiredRule = { required: true, trigger: 'blur', message: errormsg.required };
const initActiveKids = () => _.cloneDeep({
  regoIndex: undefined,
  voucherNumber: undefined,
  pin: undefined
});

const initVictoriaActiveKids = () => _.cloneDeep({
  regoIndex: undefined,
  voucherNumber: undefined,
});

const initDiscountCode = () => _.cloneDeep({
  error: '',
  code: '',
  redeemed: false,
  redeemedAmount: 0,
});

const parstAddressFormatted = (address) => {
  const {
    addressLine1,
    addressLine2,
    suburb,
    state,
    postcode,
    country
  } = address;
  return `${addressLine1}${
    addressLine2 ? ` ${addressLine2}` : ''
  }, ${suburb} ${state}, ${postcode}, ${country}`;
};

export default {
  name: 'Payment',
  props: {
    value: Object,
    isNewProduct: Boolean,
  },
  directives: {
    mask: VueMaskDirective
  },
  components: {
    GooglePayButton,
    Success
  },
  data() {
    return {
      codeRegoDetails: {},
      entityRestriction: null,
      isRecalculatingDiscounts: false,
      redeemLoading: {},
      currentIndvCartTotal: 0,
      get: _.get,
      nationalId: +process.env.VUE_APP_NATIONAL_ID,
      isLoaded: false,
      payToday: 0,
      token1: undefined,
      token2: undefined,
      processingPayment: false,
      donate: 0,
      subTitle: 'Please verify all the information displayed below is correct before proceeding.\xa0\xa0A receipt will be sent to the member\'s email address upon completion.',
      payment: {
        registrations: [],
        card: {},
        billingAddress: {
          isManual: false,
          formatted: undefined,
          addressLine1: undefined,
          addressLine2: undefined,
          suburb: undefined,
          state: undefined,
          postcode: undefined,
          country: undefined,
        },
        directSaleableItems: [],
      },
      summary: [],
      originalSummary: [],
      countries,
      rules: {
        'billingAddress.addressLine1': defaultRequiredRule,
        'billingAddress.suburb': defaultRequiredRule,
        'billingAddress.state': +process.env.VUE_APP_NATIONAL_ID === 17 ? {} : defaultRequiredRule,
        'billingAddress.postcode': defaultRequiredRule,
        'billingAddress.country': defaultRequiredRule,
      },
      additionalActiveKids: {
        regoIndex: null,
        voucherNumber: '',
        pin: ''
      },
      additionalActiveKidsModalVisible: false,
      activeKidsModalVisible: false,
      victoriaActiveKidsVisible: false,
      activeKids: initActiveKids(),
      victoriaActiveKids: initVictoriaActiveKids(),
      activeKidsRules: {
        voucherNumber: defaultRequiredRule,
        // pin: defaultRequiredRule
      },
      victoriaActiveKidsRules: {
        voucherNumber: defaultRequiredRule,
      },
      options: {
        environment: process.env.VUE_APP_PIN_ENV === 'test' ? 'TEST' : 'PRODUCTION',
        buttonColor: 'black',
        allowedCardNetworks: [
          'MASTERCARD',
          'VISA',
          'AMEX',
        ],
        allowedCardAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
        merchantInfo: {
          merchantName: 'Assemble Sports',
          merchantId: process.env.VUE_APP_GOOGLE_PAY_MERCHANT_ID,
        },
        tokenizationSpecification: {
          type: 'PAYMENT_GATEWAY',
          parameters: {
            gateway: 'pinpayments',
            gatewayMerchantId: process.env.VUE_APP_GOOGLE_PAY_MERCHANT,
          }
        }
      },
      checkoutTotalDiscount: {
        discountVoucher: {
          error: '',
          code: '',
          redeemed: false
        }
      },
      regoDiscounts: [
        {
          _id: Math.floor(100000 + Math.random() * 900000),
          discountVoucher: {
            error: '',
            code: '',
            redeemed: false
          },
          productIds: [],
        }
      ],
      totalDiscount: 0,
      productsDialogVisible: false,
      productsForDiscount: {},
      selectedRegos: [],
      limit: 0,
      discountId: undefined,
      availableProducts: [],
      lastCartTotal: 0
    };
  },
  provide() {
    return {
      getIndvCartTotal: () => this.indvCartTotal
    };
  },
  mounted() {
    this.isLoaded = false;
    // set the Discount from store
    if (this.currentDiscounts && this.currentDiscounts.length) this.regoDiscounts = _.cloneDeep(this.currentDiscounts);

    // redirect to finder if cart is empty
    const pathName = this.hasCustomEntity ? 'custom-finder' : 'finder';
    if (this.$store.getters['cart/counts'] === 0) this.$router.push({ name: pathName });
    this.isLoaded = true;
    if (this.isNewProduct) this.clearDiscounts();
  },
  methods: {
    getTotalFixedTechFee() {
      if (!this.fixedTechFee || !this.fixedTechFee.enabled || !this.summary) return 0;

      // Count only registrations that should be charged fixed tech fee
      // Exempt registrations if:
      // 1. Final total is 0 or negative (after discounts)
      // 2. PayLater is enabled
      // 3. PayAfter is enabled and payToday is 0
      const chargeableRegistrations = this.summary.filter((summaryItem) => {
        // Calculate final total after all products and discounts
        const finalTotal = summaryItem.total !== undefined
          ? summaryItem.total
          : _.sumBy(summaryItem.products, 'total');

        // Check exemption conditions for this specific registration
        const hasZeroOrNegativeTotal = finalTotal <= 0;
        const hasPayLater = summaryItem.payLater === true;
        const hasPayAfterWithZeroToday = summaryItem.payAfter === true && summaryItem.payToday === 0;

        // Return true if this registration should be charged (NOT exempt)
        return !(hasZeroOrNegativeTotal || hasPayLater || hasPayAfterWithZeroToday);
      });

      // Count individual members for bulk registrations, otherwise count as 1
      const totalMemberCount = chargeableRegistrations.reduce((count, summaryItem) => {
        // For bulk registrations, count all memberIds
        if (summaryItem.memberIds && summaryItem.memberIds.length) {
          return count + summaryItem.memberIds.length;
        }
        // For individual registrations, count as 1
        return count + 1;
      }, 0);

      return totalMemberCount * (this.fixedTechFee.amount * 100); // Convert dollars to cents
    },
    goToPayment() {
      // this.processingPayment = false;
      // reload the page
      window.location.reload();
    },
    recalculateDiscounts(idx) {
      const rego = this.payment.registrations[idx];
      const regoSummary = this.summary[idx];

      // Recalculate discounts for this registration
      if (rego.discountVoucher && rego.discountVoucher.length > 0) {
        rego.discountVoucher.forEach((voucher, voucherIdx) => {
          const productTotal = rego.payToday || rego.total;

          const redeemedAmount = voucher.type === 'dollar'
            ? Math.min(voucher.balance, productTotal)
            : Math.min((voucher.balance * productTotal) / 100, productTotal);

          // Update the voucher in the registration
          rego.discountVoucher[voucherIdx] = {
            ...voucher,
            redeemedAmount
          };

          // Update the corresponding product in the summary
          const discountProductIndex = regoSummary.products.findIndex((p) => p.name === voucher.name && p.isVoucher);
          if (discountProductIndex !== -1) {
            regoSummary.products[discountProductIndex].total = -redeemedAmount;
            regoSummary.products[discountProductIndex].price = -redeemedAmount;
          }
        });
      }

      // Update the store
      this.$store.commit('cart/update', {
        index: idx,
        registration: rego
      });

      // Recalculate total discounts
      this.recalculateTotalDiscounts();
    },

    recalculateTotalDiscounts() {
      // Recalculate the total discount across all registrations
      this.totalDiscount = this.payment.registrations.reduce((total, rego) => {
        if (rego.discountVoucher && rego.discountVoucher.length > 0) {
          return total + rego.discountVoucher.reduce((regoTotal, voucher) => regoTotal + voucher.redeemedAmount, 0);
        }
        return total;
      }, 0);
      // Update regoDiscounts if necessary
      this.regoDiscounts.forEach((discount, index) => {
        if (discount.discountVoucher && discount.discountVoucher.redeemed) {
          this.applyDiscountToTotal(index, discount.discountVoucher);
        }
      });
    },
    parsePriceTotal(val) {
      const rs = (val / 100).toFixed(2);
      if (val < 0) return `-$${(Math.abs(rs)).toFixed(2)}`;
      return `$${rs}`;
    },
    checkPayToday() {
      const getNameFromIndex = (idx) => {
        if (idx === 0) return 'First rego';
        if (idx === this.summary.length - 1) return 'Last rego';
        return `Rego #${idx + 1}`;
      };

      // eslint-disable-next-line no-restricted-syntax
      for (let idx = 0; idx < this.summary.length; idx++) {
        const rego = this.summary[idx];
        const { payToday, minPrice, payAfter } = rego;
        if (minPrice && payAfter === true && (!payToday || payToday < minPrice)) {
          const regoName = getNameFromIndex(idx);
          this.$message.error(`${regoName} has a minimum price of ${this.parsePriceTotal(minPrice)}, please input a pay today amount`);
          return false;
        }
      }
      return true;
    },
    updatePayLater(rego, idx, value) {
      _.assign(this.summary[idx], {
        payLater: value
      });
      _.assign(this.payment.registrations[idx], {
        payLater: value
      });
      this.$forceUpdate();
    },
    startApplePaySession() {
      if (!this.canShowApplePay) return this.$message.error('Apple Pay is not supported on this browser');
      const paymentRequest = this.applePayOptions;
      const session = new window.ApplePaySession(10, paymentRequest);
      datadogRum.addAction('apple-pay', 'start-session');

      session.onvalidatemerchant = (event) => {
        datadogRum.addAction('apple-pay', 'validate-merchant');
        const merchantSessionUrl = '/assemble/api/v1/portal/apple-pay/session';

        this.$http.post(merchantSessionUrl, {
          initiative_context: window.location.hostname,
          validation_url: event.validationURL,
        }).then((res) => {
          session.completeMerchantValidation(res.data.session);
        })
          .catch((error) => {
            datadogRum.addError(error, {
              source: 'apple-pay',
              type: 'merchant-validation',
            });
          });
      };

      session.oncancel = () => {
        datadogRum.addAction('apple-pay', 'cancel-session');
      };

      session.onpaymentauthorized = async (event) => {
        datadogRum.addAction('apple-pay', 'payment-authorized');
        const paymentToken = event.payment.token.paymentData;
        const data = {
          publishable_api_key: process.env.VUE_APP_PIN_PK,
          type: 'applepay',
          source: paymentToken,
        };
        const res = await this.$http.post('/assemble/api/v1/portal/apple-pay/token', data);
        if (!res.data.data) {
          this.$message.error('There has been an error, try again later.');
          session.completePayment(window.ApplePaySession.STATUS_FAILURE);
          return false;
        }
        const { token, issuing_country } = res.data.data.source;

        if (!['AU', 'NZ'].includes(issuing_country) && [14, 18].includes(+process.env.VUE_APP_NATIONAL_ID)) {
          this.$store.commit('loading', false);
          this.$message.error('International cards are not supported.');
          session.completePayment(window.ApplePaySession.STATUS_FAILURE);
          return false;
        }

        if (!token) {
          this.$store.commit('loading', false);
          this.$message.error('There has been an error, try again later.');
          session.completePayment(window.ApplePaySession.STATUS_FAILURE);
          return false;
        }

        try {
          // Handle similar to Google Pay and pay() method
          const totalWithSaleableItems = _.cloneDeep(this.totalWithSaleableItems);
          const totalDiscount = _.cloneDeep(this.discountTotal);
          this.$store.commit('cart/setIndvCartTotal', { indvCartTotal: this.indvCartTotal, indvPayTodayTotal: this.indvPayTodayTotal });
          this.currentIndvCartTotal = this.indvCartTotal;
          const checkPayTodayTotal = this.checkPayToday();
          if (!checkPayTodayTotal) {
            session.completePayment(window.ApplePaySession.STATUS_FAILURE);
            return false;
          }

          // Set payment values and clear confirmations
          await this.setPayToday();
          this.$store.commit('cart/clearConfirmations');
          this.$store.commit('cart/setTotalWithSaleableItems', totalWithSaleableItems);
          this.$store.commit('cart/setTotalDiscount', totalDiscount);

          // Use the token we received from Apple Pay endpoint directly
          // For Apple Pay, we use the same token for both registrations and saleable items
          this.token1 = token;
          this.token2 = token;

          // Check for team registrations
          const teamRegos = _.filter(this.payment.registrations, (r) => r.productType === 'team');

          if (teamRegos.length) {
            // For Apple Pay, we use the same token for all team registrations
            const allSuccess = await Promise.all(
              teamRegos.map((teamRego) => this.registerTeam(token, teamRego))
            );

            if (allSuccess.every((success) => success)) {
              this.processingPayment = true;
            } else {
              this.$store.commit('loading', false);
              session.completePayment(window.ApplePaySession.STATUS_FAILURE);
              return false;
            }
          } else {
            // No team registrations, proceed with normal flow
            this.processingPayment = true;
          }

          session.completePayment(window.ApplePaySession.STATUS_SUCCESS);
          datadogRum.addAction('apple-pay', 'payment-success');
        } catch (error) {
          session.completePayment(window.ApplePaySession.STATUS_FAILURE);
          datadogRum.addError(error, {
            source: 'apple-pay',
            type: 'payment',
          });
        }
      };

      session.begin();
      return true;
    },
    async payGoogle(event) {
      if (!_.get(event, 'paymentMethodData.tokenizationData.token')) {
        this.$message.error('An error occurred');
        return false;
      }
      this.$store.commit('loading', true);
      const data = {
        publishable_api_key: process.env.VUE_APP_PIN_PK,
        type: 'googlepay',
        source: JSON.parse(event.paymentMethodData.tokenizationData.token),
      };
      const res = await this.$http.post('/assemble/api/v1/portal/google-pay/token', data);
      if (!res.data.data) {
        this.$store.commit('loading', false);
        this.$message.error('There has been an error, try again later.');
        return false;
      }
      const { token, issuing_country } = res.data.data.source;
      if (!token) {
        this.$store.commit('loading', false);
        this.$message.error('There has been an error, try again later.');
        return false;
      }

      if (!['AU', 'NZ'].includes(issuing_country) && [14, 18].includes(+process.env.VUE_APP_NATIONAL_ID)) {
        this.$store.commit('loading', false);
        this.$message.error('International cards are not supported.');
        return false;
      }

      // Handle similar to pay() method
      const totalWithSaleableItems = _.cloneDeep(this.totalWithSaleableItems);
      const totalDiscount = _.cloneDeep(this.discountTotal);
      this.$store.commit('cart/setIndvCartTotal', { indvCartTotal: this.indvCartTotal, indvPayTodayTotal: this.indvPayTodayTotal });
      this.currentIndvCartTotal = this.indvCartTotal;
      const checkPayTodayTotal = this.checkPayToday();
      if (!checkPayTodayTotal) return false;

      // Set payment values and clear confirmations
      await this.setPayToday();
      this.$store.commit('cart/clearConfirmations');
      this.$store.commit('cart/setTotalWithSaleableItems', totalWithSaleableItems);
      this.$store.commit('cart/setTotalDiscount', totalDiscount);

      // Use the token we received from Google Pay endpoint directly
      // For Google Pay, we use the same token for both registrations and saleable items
      this.token1 = token;
      this.token2 = token;

      // Check for team registrations
      const teamRegos = _.filter(this.payment.registrations, (r) => r.productType === 'team');

      if (teamRegos.length) {
        try {
          // For Google Pay, we use the same token for all team registrations
          const allSuccess = await Promise.all(
            teamRegos.map((teamRego) => this.registerTeam(token, teamRego))
          );

          if (allSuccess.every((success) => success)) {
            this.processingPayment = true;
          } else {
            this.$store.commit('loading', false);
            return false;
          }
        } catch (err) {
          datadogRum.addError(err, {
            source: 'registerTeam',
            type: 'register-team',
          });
          this.$store.commit('loading', false);
          this.$message.error(err.message || 'There has been an error registering the teams');
          return false;
        }
      } else {
        // No team registrations, proceed with normal flow
        this.processingPayment = true;
      }

      this.$store.commit('loading', false);
      return true;
    },

    // Helper method to extract card details from Google Pay response
    getCardDetailsFromGooglePay(event) {
      try {
        const paymentData = event.paymentMethodData;
        const tokenData = JSON.parse(paymentData.tokenizationData.token);

        // Extract card information if available
        if (paymentData.info && paymentData.info.cardNetwork && paymentData.info.cardDetails) {
          return {
            // We may not have all these details from Google Pay, but we provide what we can
            number: paymentData.info.cardDetails,
            expiryMonth: '12', // Default value, might not be available from Google Pay
            expiryYear: '25', // Default value, might not be available from Google Pay
            googlePayToken: tokenData
          };
        }

        // If no detailed card info, return basic info
        return {
          expiryMonth: '12', // Default value
          expiryYear: '25', // Default value
          googlePayToken: tokenData
        };
      } catch (error) {
        console.error('Error extracting card details from Google Pay', error);
        return null;
      }
    },
    getFamilyMemberDetails(r) {
      const memberDetails = _.map((r.familyRegistrations), (rego) => ({
        playerName: `${rego.profile.firstName} ${rego.profile.lastName}`,
        age: calculateMemberAge(rego.profile.dob, this.endOfYear),
        memberType: rego.memberType,
      }));

      return memberDetails;
    },
    getFamilyMemberIds(r) {
      const memberIds = _.map((r.familyRegistrations), (rego) => rego.memberId);
      return _.join(_.map(memberIds, String), '');
    },
    getRegoUniqueKey(rego) {
      if (rego.productType === 'family') {
        return `${this.getFamilyMemberIds(rego)}_${rego.product._id}`;
      }
      if (rego.productType === 'indv-to-team' && rego.team) {
        return `${rego.memberId}_${rego.product._id}_${rego.team.name || rego.team._id || 'team'}`;
      }
      return `${rego.memberId}_${rego.product._id}`;
    },
    clearDiscounts() {
      this.$store.commit('cart/clearDiscounts');

      if (_.isObject(this.regoDiscounts)) {
        this.regoDiscounts = [{
          _id: Math.floor(100000 + Math.random() * 900000),
          discountVoucher: {
            error: '',
            code: '',
            redeemed: false
          },
          productIds: [],
        }];
      }

      for (let index = 0; index <= this.payment.registrations.length - 1; index++) {
        const rego = this.payment.registrations[index];

        rego.discountVoucher = [];

        // Update cart store
        this.$store.commit('cart/update', {
          index,
          registration: rego
        });
      }

      this.$store.commit('cart/updateRegoDiscounts', {
        _id: Math.floor(100000 + Math.random() * 900000),
        discountVoucher: {
          error: '',
          code: '',
          redeemed: false
        },
        productIds: [],
      });
    },
    removeAdditionalVoucher(id) {
      const newRegoDiscounts = _.filter(this.regoDiscounts, (rego) => rego._id !== id);
      this.regoDiscounts = newRegoDiscounts;
      this.$store.commit('cart/updateRegoDiscounts', this.regoDiscounts);
    },
    newDiscountVoucher() {
      this.regoDiscounts.push({
        _id: Math.floor(100000 + Math.random() * 900000),
        discountVoucher: {
          error: '',
          code: '',
          redeemed: false
        },
        productIds: [],
      });
      this.$store.commit('cart/updateRegoDiscounts', this.regoDiscounts);
    },
    cancelRedeemedNew(discount) {
      // console.log({
      //   discount,
      //   cart: 'cancelRedeemedNew',
      //   payment: _.cloneDeep(this.payment),
      // });
      for (let index = 0; index <= this.payment.registrations.length - 1; index++) {
        const rego = this.payment.registrations[index];
        const summaryRego = this.summary[index];

        // console.log({
        //   index,
        //   rego,
        //   cart: 'cancelRedeemedNew',
        //   summaryRego,
        //   discountVoucher: this.payment.registrations[index].discountVoucher,
        // });

        const voucher = _.filter(rego.discountVoucher, (v) => v.code !== discount.code);
        // console.log({
        //   rego,
        //   voucher,
        //   cart: 'cancelRedeemedNew',
        // });
        rego.discountVoucher = voucher;
        summaryRego.discountVoucher = voucher;

        // console.log({
        //   cart: 'cancelRedeemedNew',
        //   summaryRegoDiscountVoucher: this.summary[index].discountVoucher,
        //   discountVoucher: this.payment.registrations[index].discountVoucher,
        // });

        // Update cart store
        this.$store.commit('cart/update', {
          index,
          registration: rego
        });
      }
      this.regoDiscounts[discount.index].discountVoucher = initDiscountCode();
      this.$store.commit('cart/updateRegoDiscounts', this.regoDiscounts);
    },
    async initRedeem(id) {
      if (this.redeemLoading[id]) return; // Prevent double execution

      this.$set(this.redeemLoading, id, true); // Set loading state

      try {
        const discountIndex = _.findIndex(this.regoDiscounts, (discount) => discount._id === id);
        const { code } = this.regoDiscounts[discountIndex].discountVoucher;
        // console.log({
        //   code,
        //   discountIndex,
        //   regoDiscounts: this.regoDiscounts[discountIndex]
        // });

        if (!code) return;

        const count = _.countBy(this.codesInUsed);
        if (count[code] > 1 && this.codesInUsed.includes(code)) {
          this.regoDiscounts[discountIndex].discountVoucher.error = 'Code already used.';
          return;
        }

        await this.discountCodeCheck(discountIndex, code);

        const res = await this.$http.post('assemble/api/v1/portal/discount-codes/redeem-check', {
          code,
        });
        this.codeRegoDetails = _.get(res, 'data.data', {});
      } finally {
        this.$set(this.redeemLoading, id, false); // Clear loading state
      }
    },
    updateCheckoutTotalDiscount(total) {
      const checkoutTotalDiscountIndex = this.regoDiscounts.findIndex((d) => d.type === 'checkoutTotal');
      if (checkoutTotalDiscountIndex !== -1) {
        const discount = this.regoDiscounts[checkoutTotalDiscountIndex];
        // Remove the old discount
        this.regoDiscounts.splice(checkoutTotalDiscountIndex, 1);
        // Only reapply if there's still a valid discount
        if (discount && discount.discountVoucher && discount.discountVoucher.balance) {
          this.applyDiscountToTotal(checkoutTotalDiscountIndex, {
            ...discount.discountVoucher,
            amount: discount.discountVoucher.balance,
            campaignDiscountType: 'checkoutTotal'
          }, total);
        }
      }
    },
    calculateCartTotal() {
      let total = 0;
      _.forEach(this.summary, (i) => {
        if (i.payAfter) {
          // For payAfter registrations, always use payToday amount (even if 0)
          total += i.payToday || 0;
        } else if (!i.payLater) {
          // Only add product totals for non-payAfter, non-payLater registrations
          _.forEach(i.products, (p) => {
            total += p.total;
          });
        }
      });
      return total > 0 ? total : 0;
    },
    calculateEntitySpecificTotal(sourceEntity) {
      console.log('sourceEntity', sourceEntity);

      let total = 0;
      _.forEach(this.summary, (summaryItem, index) => {
        const registration = this.payment.registrations[index];
        if (registration && registration.entityId === sourceEntity.entityId && registration.entityType === sourceEntity.entityType) {
          if (summaryItem.payAfter && summaryItem.payToday > 0) {
            total += summaryItem.payToday;
          } else {
            _.forEach(summaryItem.products, (p) => {
              if (!summaryItem.payLater) {
                total += p.total;
              }
            });
          }
        }
      });
      console.log('total', total);

      return total > 0 ? total : 0;
    },
    applyDiscountToTotal(discountIndex, discount, total) {
      if (!discount || !discount.campaignDiscountType) {
        console.warn('Invalid discount or missing campaignDiscountType', discount);
        return false;
      }

      const {
        _id, type, name, amount, description, code, campaignDiscountType
      } = discount;

      // Calculate the applicable total based on entity restrictions
      let productTotal = total || this.total;

      // If there's an entity restriction and it's a checkout total discount
      if (this.entityRestriction && this.entityRestriction.requiredEntity && campaignDiscountType === 'checkoutTotal') {
        const { requiredEntity } = this.entityRestriction;
        productTotal = this.calculateEntitySpecificTotal(requiredEntity.sourceEntity);

        // If no eligible items found, show error message
        if (productTotal === 0) {
          this.regoDiscounts[discountIndex].discountVoucher.error = this.entityRestriction.message || 'This discount code is not applicable to any items in your cart';
          return false;
        }
      }

      const redeemedAmount = type === 'dollar'
        ? Math.min(amount, productTotal)
        : Math.min((amount * productTotal) / 100, productTotal);

      const discountVoucher = {
        _id,
        code,
        name,
        description,
        type,
        balance: amount,
        redeemedAmount,
        redeemed: true,
        index: discountIndex,
        voucherType: campaignDiscountType,
        entityRestriction: this.entityRestriction,
      };

      this.$set(this.regoDiscounts, discountIndex, {
        discountVoucher,
        type: campaignDiscountType
      });

      this.$store.commit('cart/updateRegoDiscounts', this.regoDiscounts);

      // After checkout total discount is applied, update summary and auto-adjust pay-today if needed
      this.updateSummary();
      this.$nextTick(() => this.adjustPayTodayAfterDiscount());

      return true;
    },
    recalculateRegoDiscounts(total, transactionFee) {
      // console.log('Cart Recalculating rego discounts...');
      // console.log({
      //   total,
      //   transactionFee,
      //   cartRegoDiscounts: _.cloneDeep(this.regoDiscounts),
      //   regoIndex: this.regoDiscounts[0].regoIndex,
      //   summary: this.summary
      // });
      const regoDiscounts = _.cloneDeep(this.regoDiscounts);
      const voucherRedeemedAmount = _.get(regoDiscounts, '[0].discountVoucher.redeemedAmount', 0);
      _.forEach(this.regoDiscounts, (discount) => {
        // console.log('Cart Recalculating discount:', discount);
        if (!discount.discountVoucher) return;
        const totalWithTransactionFee = +(total + transactionFee).toFixed();
        const { type, balance } = discount.discountVoucher;
        // console.log({
        //   cartTotalWithTransactionFee: totalWithTransactionFee,
        //   balance,
        //   type,
        // });
        const redeemedAmount = type === 'dollar'
          ? Math.min(balance, totalWithTransactionFee)
          : Math.min(voucherRedeemedAmount, totalWithTransactionFee);

        // console.log({
        //   cartRedeemedAmount: redeemedAmount,
        //   voucherRedeemedAmount,
        // });
        // eslint-disable-next-line no-param-reassign
        discount.discountVoucher.redeemedAmount = redeemedAmount;
        // console.log({
        //   totalWithTransactionFee,
        //   balance,
        //   redeemedAmount,
        //   type
        // });
      });
    },
    // Auto-adjust payToday when a discount reduces the registration total below the entered first installment
    adjustPayTodayAfterDiscount() {
      try {
        this.summary.forEach((rego, index) => {
          if (!rego || !rego.payAfter) return;

          const newMax = Number(rego.total || 0);
          const currentPayToday = Number(rego.payToday || 0);
          const min = Number(rego.minPrice || 0);

          // If the new total is below the entered amount, cap it to the new maximum
          if (currentPayToday > newMax) {
            const adjusted = newMax; // always cap at the new maximum

            // Update summary model
            this.$set(this.summary[index], 'payToday', adjusted);

            // Mirror to store-backed registrations and commit so totals recalc correctly
            const regoStore = this.payment.registrations[index];
            if (regoStore) {
              // eslint-disable-next-line no-param-reassign
              regoStore.payToday = adjusted;
              this.$store.commit('cart/update', {
                index,
                registration: regoStore
              });
            }

            // Inform member
            if (this.$message) {
              this.$message({
                type: 'info',
                message: 'Your first installment has been adjusted to the new maximum due to the applied discount.'
              });
            }
            this.$forceUpdate();
          } else if (newMax < min && currentPayToday !== newMax) {
            // Edge case: new total below configured minimum. Set to new total and inform.
            this.$set(this.summary[index], 'payToday', newMax);
            const regoStore = this.payment.registrations[index];
            if (regoStore) {
              // eslint-disable-next-line no-param-reassign
              regoStore.payToday = newMax;
              this.$store.commit('cart/update', {
                index,
                registration: regoStore
              });
            }
            if (this.$message) {
              this.$message({
                type: 'info',
                message: 'Your first installment has been adjusted to the updated total due to the applied discount.'
              });
            }
            this.$forceUpdate();
          }
        });
      } catch (e) {
        // No-op: avoid blocking the redeem flow on UI adjustments
      }
    },
    async applyDiscountToEntity(discountIndex) {
      const { code } = this.regoDiscounts[discountIndex].discountVoucher;
      const redeemed = [];
      const processedEntityIds = new Set(); // Track which entities have been processed

      // console.log({
      //   cart: 'applyDiscountToEntity',
      //   discountIndex,
      //   code,
      //   processedEntityIds,
      //   summary: _.get(this, 'summary'),
      // });

      for (let index = 0; index <= this.summary.length - 1; index++) {
        try {
          const rego = this.payment.registrations[index];
          const summary = this.summary[index];

          // if (processedEntityIds.has(rego.entityId)) {
          //   // eslint-disable-next-line no-continue
          //   continue;
          // }
          rego.discountVoucher = [];
          if (!rego.discountVoucher) {
            rego.discountVoucher = [];
          }

          rego.discountVoucher.error = '';

          const entityId = rego.eventId || rego.entityId;

          // eslint-disable-next-line no-await-in-loop
          const res = await this.$http.post('assemble/api/v1/portal/discount-codes/redeem', {
            code,
            entityType: (rego.eventId || rego.entityType === 'event') ? 'event' : 'membership',
            entityId: entityId,
          });

          const {
            _id, limit, totalLimit, campaignDiscountType,
            type, name, amount, description, saleableItem
          } = res.data.data;

          // eslint-disable-next-line no-continue
          if (!_.get(res, 'data.data')) continue;

          // Track that we've processed this entity
          processedEntityIds.add(entityId);

          // if (!_.get(res.data.data)) this.regoDiscounts[discountIndex].discountVoucher.error = 'Discount cannot be applied to this event / membership, please contact your administrator';

          if (_.get(rego, 'product._id') && _id && this.regoDiscounts[discountIndex] && !(this.regoDiscounts[discountIndex].productIds || []).includes(rego.product._id)) {
            if (this.regoDiscounts[discountIndex].productIds) {
              this.regoDiscounts[discountIndex].productIds.push(_.get(rego, 'product._id'));
            } else {
              this.regoDiscounts[discountIndex].productIds = [_.get(rego, 'product._id')];
            }
          }

          // validate limitation
          const noOfUsed = _.sumBy(_.map(this.payment.registrations, 'discountVoucher'), (d) => d && d._id === _id);
          if (noOfUsed && noOfUsed + limit >= totalLimit) {
            summary.discountVoucher.error = 'Discount code already exceeds limit';
            // eslint-disable-next-line no-continue
            continue;
          }

          let productTotal;
          if (campaignDiscountType === 'saleable') {
            const foundItemIndex = _.findIndex(rego.saleableItems, (s) => s._id === saleableItem);
            productTotal = this.getTotalWithTransactionFee(_.get(rego, `saleableItems[${foundItemIndex}].price`, 0) * _.get(rego, `saleableItems[${foundItemIndex}].qty`, 0));
          } else if (campaignDiscountType === 'registration') {
            const products = _.filter(summary.products, (p) => p.voucherType !== 'saleable' && !p.isSaleableItem);
            productTotal = Math.abs(_.sumBy(products, 'total'));
          } else if (campaignDiscountType === 'entity') {
            productTotal = summary.products[0].total; // discount the product price only- zendesk 5095
            const { cartTotal } = this;
            if (productTotal > cartTotal) {
              productTotal = cartTotal;
            }
          } else {
            productTotal = _.sumBy(summary.products, 'total');
          }

          let redeemedAmount = type === 'dollar' ? amount : ((amount * productTotal) / 100);
          if (redeemedAmount > productTotal) redeemedAmount = productTotal;
          const actualRedeemedAmount = parseInt(redeemedAmount);

          const discountVoucher = Object.freeze({
            _id,
            code,
            name,
            description,
            type,
            balance: amount,
            redeemedAmount: actualRedeemedAmount,
            actualRedeemedAmount,
            redeemed: true,
            index: discountIndex,
            voucherType: campaignDiscountType,
          });

          console.log({ discountVoucher });

          if (productTotal > 0) rego.discountVoucher.push(discountVoucher);

          this.regoDiscounts[discountIndex].type = campaignDiscountType;
          this.regoDiscounts[discountIndex].discountVoucher = Object.freeze(discountVoucher);
          this.regoDiscounts[discountIndex].regoIndex = index;
          this.regoDiscounts[discountIndex].redeemed = true;

          redeemed.push(true);
          console.log({ redeemed });

          // Update cart store
          this.$store.commit('cart/update', {
            index,
            registration: rego
          });
        } catch (err) {
          datadogRum.addError(err, {
            source: 'applyDiscountToEntity',
            type: 'redeem-discount',
          });
        }
      }

      if (!redeemed.includes(true)) this.regoDiscounts[discountIndex].discountVoucher.error = 'Invalid Code';

      this.$store.commit('cart/updateRegoDiscounts', this.regoDiscounts);
      // Ensure summary reflects the updated discounts, then auto-adjust pay-today if needed
      this.updateSummary();
      this.$nextTick(() => this.adjustPayTodayAfterDiscount());
    },
    async applyDiscountToSelectedEntity() {
      const discountIndex = _.findIndex(this.regoDiscounts, (discount) => discount._id === this.discountId);
      const { code } = this.regoDiscounts[discountIndex].discountVoucher;

      // console.log({
      //   selectedRegosLength: this.selectedRegos.length - 1,
      // });

      for (let index = 0; index <= this.selectedRegos.length - 1; index++) {
        // console.log('Applying Discount');
        try {
          // Find the registration by matching the unique key
          const selectedKey = this.selectedRegos[index];
          let foundIndex = -1;

          for (let i = 0; i < this.payment.registrations.length; i++) {
            const reg = this.payment.registrations[i];

            if (this.getRegoUniqueKey(reg) === selectedKey) {
              foundIndex = i;
              break;
            }
          }

          if (foundIndex === -1) {
            console.log('can find reg ');

            console.warn('Could not find registration for selected key:', selectedKey);
            // eslint-disable-next-line no-continue
            continue;
          }

          const rego = this.payment.registrations[foundIndex];
          const summary = this.summary[foundIndex];
          if (!rego.discountVoucher) {
            rego.discountVoucher = [];
          }

          rego.discountVoucher.error = '';

          // eslint-disable-next-line no-await-in-loop
          const res = await this.$http.post('assemble/api/v1/portal/discount-codes/redeem', {
            code,
            entityType: (rego.eventId || rego.entityType === 'event') ? 'event' : 'membership',
            entityId: rego.entityId
          });

          const {
            _id, limit, totalLimit, campaignDiscountType,
            type, name, amount, description, saleableItem
          } = res.data.data;

          // const regoDiscounts = _.cloneDeep(this.regoDiscounts);
          // // eslint-disable-next-line no-restricted-syntax
          // for (const r of regoDiscounts) {
          //   if (r.discountVoucher.name === name) {
          //     this.$message.error('Cannot Redeem from the Same Discount');
          //     return;
          //   }
          // }
          const regoDetails = this.codeRegoDetails;
          const regoDiscountVouchers = _.get(rego, 'discountVoucher', []);
          const regoDiscountVoucherName = _.map(regoDiscountVouchers, 'name');
          const resVoucherName = _.get(regoDetails, 'name', '');
          const hasName = _.includes(regoDiscountVoucherName, resVoucherName);
          if (hasName) {
            console.log('test bug');

            this.$message.error('Cannot Redeem from the Same Discount');
            return;
          }

          // return;

          if (!_.get(res.data.data)) {
            // this.regoDiscounts[discountIndex].discountVoucher.error = 'Discount cannot be applied to this event / membership, please contact your administrator';
            this.productsDialogVisible = false;
          }

          if (_.get(rego, 'product._id') && _id && this.regoDiscounts[discountIndex] && !this.regoDiscounts[discountIndex].productIds.includes(_id)) this.regoDiscounts[discountIndex].productIds.push(_.get(rego, 'product._id'));

          // validate limitation
          const noOfUsed = _.sumBy(_.map(this.payment.registrations, 'discountVoucher'), (d) => d && d._id === _id);
          if (noOfUsed && noOfUsed + limit >= totalLimit) {
            summary.discountVoucher.error = 'Discount code already exceeds limit';
            return;
          }

          let productTotal;
          if (campaignDiscountType === 'saleable') {
            const foundItemIndex = _.findIndex(rego.saleableItems, (s) => s._id === saleableItem);
            productTotal = this.getTotalWithTransactionFee(rego.saleableItems[foundItemIndex].price) * rego.saleableItems[foundItemIndex].qty;
          } else if (campaignDiscountType === 'registration') {
            const products = _.filter(summary.products, (p) => p.voucherType !== 'saleable' && !p.isSaleableItem);
            productTotal = Math.abs(_.sumBy(products, 'total'));
          } else {
            productTotal = _.sumBy(summary.products, 'total');
          }

          let redeemedAmount = type === 'dollar' ? amount : ((amount * productTotal) / 100);
          // console.log({
          //   redeemedAmount
          // });
          if (redeemedAmount > productTotal) redeemedAmount = productTotal;
          const discountVoucher = {
            _id,
            code,
            name,
            description,
            type,
            balance: amount,
            redeemedAmount,
            redeemed: true,
            index: discountIndex,
            voucherType: campaignDiscountType,
          };

          // console.log({
          //   discountVoucher,
          //   discountVoucherRedeemedAmount: _.get(discountVoucher, 'redeemedAmount'),
          //   rego,
          //   campaignDiscountType,
          //   summary,
          //   productTotal,
          //   amount,
          //   redeemedAmount,
          // });

          rego.discountVoucher.push(discountVoucher);
          // Update cart store
          this.$store.commit('cart/update', {
            index: foundIndex,
            registration: rego
          });

          this.regoDiscounts[discountIndex].type = campaignDiscountType;
          this.regoDiscounts[discountIndex].discountVoucher = discountVoucher;
          // console.log('Cart Rego Discounts Updated in Selection');
        } catch (err) {
          datadogRum.addError(err, {
            source: 'applyDiscountToSelectedEntity',
            type: 'redeem-discount',
          });
        }
      }

      this.$store.commit('cart/updateRegoDiscounts', this.regoDiscounts);
      this.availableProducts = [];
      this.selectedRegos = [];
      this.productsDialogVisible = false;
    },
    isQtyDisabled(product) {
      if (product.isSaleableItem) return false;
      if (product.isSaleableItem !== undefined && product.isSaleableItem === false) return true;
      if (product.feeRequired !== undefined && product.feeRequired === false) return false;

      return true;
    },
    updateCstmFeeQty(index, product) {
      const rego = this.payment.registrations[index];
      const regoSummary = this.summary[index];

      rego.product.customFees.qty = product.qty;
      rego.product.customFees.total = product.qty * product.price;
      // Update cart store
      this.$store.commit('cart/update', {
        index,
        registration: rego
      });
      _.forEach(regoSummary.products, (p) => {
        if (p.isCustomFees) {
          // eslint-disable-next-line no-param-reassign
          p.qty = product.qty;
          // eslint-disable-next-line no-param-reassign
          p.total = product.qty * product.price;
        }
      });

      this.$message.success('Successfully updated');
    },
    checkMaxQty(rego) {
      if (
        rego.multiplePurchaseEnable
        || rego.multiplePurchaseEnable === undefined
      ) {
        return Infinity;
      }
      return 1;
    },
    getTotalWithTransactionFee(total) {
    // If a national has product transaction fee setting, apply it to product
      const preference = this.$store.getters['national/paymentPreference'];
      const { addToProduct } = preference;
      if (!addToProduct) return total;
      return +(total * ((100 + addToProduct) / 100)).toFixed();
    },
    cancelRedeemed(index) {
      const rego = this.payment.registrations[index];

      rego.discountVoucher = [];

      // Update cart store
      this.$store.commit('cart/update', {
        index,
        registration: rego
      });
    },
    async redeem(index) {
      console.log('redeem');
      const rego = this.payment.registrations[index];
      const summary = this.summary[index];
      console.log({ summary });

      if (!rego.discountVoucher) {
        rego.discountVoucher = [];
      }

      rego.discountVoucher.error = '';
      console.log({ voucher: summary.discountVoucher });

      this.$http.post('assemble/api/v1/portal/discount-codes/redeem', {
        code: summary.discountVoucher.code,
        entityType: rego.entityType,
        entityId: rego.entityId
      }).then((res) => {
        const {
          _id, limit, totalLimit, code,
          type, name, amount, description, isSaleableItem, saleableItem, isRegistration
        } = res.data.data;

        // validate limitation
        const noOfUsed = _.sumBy(_.map(this.payment.registrations, 'discountVoucher'), (d) => d && d._id === _id);
        if (noOfUsed && noOfUsed + limit >= totalLimit) {
          summary.discountVoucher.error = 'Discount code already exceeds limit';
          return;
        }

        let productTotal;
        if (isSaleableItem) {
          const foundItemIndex = _.findIndex(rego.saleableItems, (s) => s._id === saleableItem);
          productTotal = this.getTotalWithTransactionFee(rego.saleableItems[foundItemIndex].price) * rego.saleableItems[foundItemIndex].qty;
        } else if (isRegistration) {
          const saleableItemTotal = _.sumBy(rego.saleableItems, (item) => this.getTotalWithTransactionFee(item.price) * item.qty);
          productTotal = Math.abs(_.sumBy(summary.products, 'total') - saleableItemTotal);
        } else {
          productTotal = _.sumBy(summary.products, 'total');
        }

        let redeemedAmount = type === 'dollar' ? amount : ((amount * productTotal) / 100);
        redeemedAmount = +redeemedAmount.toFixed();
        if (redeemedAmount > productTotal) redeemedAmount = productTotal;
        rego.discountVoucher = {
          _id,
          code,
          name,
          description,
          type,
          balance: amount,
          redeemedAmount,
          redeemed: true
        };
        // Update cart store
        this.$store.commit('cart/update', {
          index,
          registration: rego
        });
      }).catch((err) => {
        datadogRum.addError(err, {
          source: 'redeem',
          type: 'redeem-discount',
        });
        summary.discountVoucher.error = 'Discount cannot be applied to this event / membership, please contact your administrator';
      });
    },
    searchCountry(query, cb) {
      if (query && query !== '') {
        setTimeout(() => {
          cb(this.countries.filter((item) => item.label.toLowerCase()
            .indexOf(query.toLowerCase()) > -1));
        }, 200);
      } else {
        cb([]);
      }
    },

    remove(index, type) {
      const text = type === 'family' ? 'When removing this option all selected members will be removed and would need to be added again.' : 'Are you sure you want to remove this registration?';
      this.$confirm(text, 'Confirm', {
        distinguishCancelAndClose: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
      }).then(() => {
        const registration = this.payment.registrations[index];
        if (registration.isRequiredRego) {
          const foundRego = _.find(this.payment.registrations, (r) => r.product._id === registration.requiredForProduct._id);
          if (foundRego) {
            const regoName = foundRego.product.name || foundRego.entityName;
            this.$message.error(`This product is required for ${regoName}. Please remove that product first.`);
            return;
          }
        }
        this.$store.commit('cart/remove', index);
        this.payment.registrations.splice(index, 1);
        this.summary.splice(index, 1);

        // Redirect to finder if no registration
        const pathName = this.hasCustomEntity ? 'custom-finder' : 'finder';

        if (this.payment.registrations.length === 0) {
          this.$store.commit('cart/clearCart');
          this.$router.push({ name: pathName });
        }
      });
    },
    edit(index) {
      const registration = _.cloneDeep(this.payment.registrations[index]);
      const { memberId } = registration;
      if (registration.entityType === 'event') {
        if (registration.productType === 'indv') {
          const pathName = this.hasCustomEntity ? 'custom-event-register-individual' : 'event-register-individual';
          this.$router.push({ name: pathName, params: { editingRego: registration, memberId, editing: true } });
        } else if (registration.productType === 'indv-to-team') {
          const pathName = this.hasCustomEntity ? 'custom-event-register-individual-to-team' : 'event-register-individual-to-team';
          this.$router.push({ name: pathName, params: { editingRego: registration, memberId, editing: true } });
        }
      } else if (registration.entityType === 'membership') {
        const pathName = this.hasCustomEntity ? 'custom-membership-register-individual' : 'membership-register-individual';
        this.$router.push({ name: pathName, params: { editingRego: registration, memberId, editing: true } });
      }
    },

    fillAddress(address) {
      _.assign(this.payment.billingAddress, address);

      // this.payment.billingAddress = {
      //   formatted: address.formatted,
      //   addressLine1: address.addressLine1,
      //   addressLine2: address.addressLine2,
      //   suburb: address.suburb,
      //   state: address.state,
      //   postcode: address.postcode,
      //   country: address.country,
      // };
    },
    showActiveKidsModal(index) {
      this.activeKids.regoIndex = index;
      this.activeKids.pin = this.summary[index].voucherPin;
      this.activeKidsModalVisible = true;
    },
    showAdditionalActiveKidsModal(index) {
      this.additionalActiveKids.regoIndex = index;
      this.additionalActiveKids.pin = this.summary[index].voucherPin;
      this.additionalActiveKidsModalVisible = true;
    },
    showVICActiveKidsModal(index) {
      this.victoriaActiveKids.regoIndex = index;
      this.victoriaActiveKids.voucherNumber = '';
      this.victoriaActiveKidsVisible = true;
    },
    handleActiveKidsClose(done) {
      this.activeKids = initActiveKids();
      done();
    },
    handleVictoriaActiveKidsClode(done) {
      this.victoriaActiveKids = initVictoriaActiveKids();
      done();
    },
    addActiveKidsVoucher() {
      const { regoIndex: index, voucherNumber, pin } = this.activeKids;
      this.$refs.activeKids.validate((valid) => {
        if (valid) {
          const foundBarcode = _.find(this.payment.registrations, (r) => r.activeKidsVoucher && r.activeKidsVoucher.barcode === this.activeKids.voucherNumber);
          if (foundBarcode) return this.$message.error('Voucher code has already been applied.');

          this.$store.commit('loading', { loading: true, text: 'Loading...' });
          this.$http.post('/assemble/api/v1/portal/registrations/nsw-voucher', {
            barcode: this.activeKids.voucherNumber,
            pin: this.activeKids.pin,
            regoEntityId: this.payment.registrations[index].entityId,
            regoEntityType: this.payment.registrations[index].entityType
          }).then((res) => {
            const balanceInDollar = res.data.data;
            const balance = balanceInDollar * 100;
            const rego = this.payment.registrations[index];
            const regoSummary = this.summary[index];
            const eligibleTotal = regoSummary.products
              .filter((p) => !p.isSaleableItem)
              .reduce((acc, product) => acc + product.total, 0);

            const redeemedAmount = Math.min(eligibleTotal, balance);

            // Add to registrations
            rego.activeKidsVoucher = {
              barcode: voucherNumber,
              pin,
              balance,
              redeemedAmount
            };

            // Update summary
            regoSummary.products.push({
              name: 'Active Kids Voucher',
              description: '',
              qty: 1,
              total: -redeemedAmount,
              price: -redeemedAmount,
              isVoucher: true
            });

            // Update cart store
            this.$store.commit('cart/update', {
              index,
              registration: rego
            });

            this.activeKids = initActiveKids();
            this.activeKidsModalVisible = false;

            this.$store.commit('loading', false);
          }).catch((e) => {
            this.$message.error(e.response.data.message);
            this.$store.commit('loading', false);
          });
        }
        return true;
      });
    },
    addAdditionalActiveKidsVoucher() {
      const { regoIndex: index, voucherNumber, pin } = this.additionalActiveKids;
      this.$refs.additionalActiveKids.validate((valid) => {
        if (valid) {
          const isSameAsActiveKids = this.payment.registrations[index].activeKidsVoucher.barcode === this.additionalActiveKids.voucherNumber;
          if (isSameAsActiveKids) return this.$message.error('Voucher code has already been applied.');

          const foundBarcode = _.find(this.payment.registrations, (r) => r.additionalActiveKidsVoucher && r.additionalActiveKidsVoucher.barcode === this.additionalActiveKids.voucherNumber);
          if (foundBarcode) return this.$message.error('Voucher code has already been applied.');

          this.$store.commit('loading', { loading: true, text: 'Loading...' });
          this.$http.post('/assemble/api/v1/portal/registrations/nsw-voucher', {
            barcode: this.additionalActiveKids.voucherNumber,
            pin: this.additionalActiveKids.pin,
            regoEntityId: this.payment.registrations[index].entityId,
            regoEntityType: this.payment.registrations[index].entityType
          }).then((res) => {
            const balanceInDollar = res.data.data;
            const balance = balanceInDollar * 100;
            const rego = this.payment.registrations[index];
            const regoSummary = this.summary[index];
            const eligibleTotal = regoSummary.products
              .filter((p) => !p.isSaleableItem)
              .reduce((acc, product) => acc + product.total, 0);

            if (eligibleTotal <= 0) {
              this.$message.error('All eligible costs have been covered by the previous voucher. No additional discount can be applied.');
              this.$store.commit('loading', false);
              return;
            }

            const redeemedAmount = Math.min(eligibleTotal, balance);

            rego.additionalActiveKidsVoucher = {
              barcode: voucherNumber,
              pin,
              balance,
              redeemedAmount
            };

            regoSummary.products.push({
              name: 'Additional Active Kids Voucher',
              description: '',
              qty: 1,
              total: -redeemedAmount,
              price: -redeemedAmount,
              isVoucher: true
            });

            this.$store.commit('cart/update', {
              index,
              registration: rego
            });

            this.additionalActiveKids = initActiveKids(); // Assuming you have a similar method to reset the form
            this.additionalActiveKidsModalVisible = false; // Assuming you manage visibility similarly

            this.$store.commit('loading', false);
          }).catch((e) => {
            this.$message.error(e.response.data.message);
            this.$store.commit('loading', false);
          });
        }
        return true;
      });
    },
    addVICActiveKidsVoucher() {
      const { regoIndex: index, voucherNumber } = this.victoriaActiveKids;
      this.$refs.victoriaActiveKids.validate((valid) => {
        if (valid) {
          const foundBarcode = _.find(this.payment.registrations, (r) => r.victoriaActiveKids && r.victoriaActiveKids.voucherNumber === voucherNumber);
          if (foundBarcode) return this.$message.error('Voucher code has already been applied.');

          // Format: G5-1234567-EW64 (G5 = Group, 1234567 = Provider Number, EW64 = Pin)
          // Check if voucher number matches format (uppercase, length)
          const regex = /^[A-Z0-9]{2}-[0-9]{7}-[A-Z0-9]{4}$/;
          if (!regex.test(voucherNumber)) return this.$message.error('Voucher number is invalid.');

          const balance = 20000;
          const rego = this.payment.registrations[index];
          const regoSummary = this.summary[index];
          const registrationFeeTotal = (regoSummary.products || [])
            .find((p) => p.name === 'Registration Fee')
            .total;
          const redeemedAmount = registrationFeeTotal >= balance ? balance : regoSummary.total;

          // Add to registrations
          rego.activeKidsVoucher = {
            barcode: voucherNumber,
            pin: '0000',
            balance: 0,
            redeemedAmount,
            price: -redeemedAmount
          };

          // Update summary
          this.summary[index].products.push({
            name: 'Active Kids VIC',
            description: '',
            qty: 1,
            total: -redeemedAmount,
            price: -redeemedAmount,
            isVoucher: true
          });

          // Update cart store
          this.$store.commit('cart/update', {
            index,
            registration: rego
          });

          this.victoriaActiveKids = initVictoriaActiveKids();
          this.victoriaActiveKidsVisible = false;

          this.$store.commit('loading', false);
        }
        return true;
      });
    },
    deleteVoucher(index) {
      const rego = this.payment.registrations[index];
      delete rego.activeKidsVoucher;

      // Update cart store
      this.$store.commit('cart/update', {
        index,
        registration: rego
      });

      const regoSummary = this.summary[index];
      const voucherIndex = _.findIndex(regoSummary.products, (p) => p.isVoucher === true);
      regoSummary.products.splice(voucherIndex, 1);
    },
    deleteSaleableItem(index, item, itemIndex) {
      this.$confirm('Are you sure you want to remove this item?', 'Confirm', {
        distinguishCancelAndClose: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
      }).then(() => {
        const rego = this.payment.registrations[index];
        const foundItemIndex = _.findIndex(rego.saleableItems, (i) => i._id === item._id);
        if (foundItemIndex > -1) {
          if (rego.saleableItems[foundItemIndex].required) {
            this.$message.error('You must have at least one item for this registration.');
          } else {
            rego.saleableItems.splice(foundItemIndex, 1);
            // Update cart store
            this.$store.commit('cart/update', {
              index,
              registration: rego
            });
            const regoSummary = this.summary[index];
            regoSummary.products.splice(itemIndex, 1);
          }
        }
      }).catch((err) => {
        datadogRum.addError(err, {
          source: 'deleteSaleableItem',
          type: 'delete-saleable-item',
        });
      });

    // const product
    },
    deleteDirectSaleableItem(idx) {
      this.$confirm('Are you sure you want to remove this item?', 'Confirm', {
        distinguishCancelAndClose: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
      }).then(() => {
        this.payment.directSaleableItems.splice(idx, 1);
        // Update cart store
        this.$store.commit('cart/updateDirectStoreItems', {
          saleableItems: this.payment.directSaleableItems
        });
      }).catch((err) => {
        datadogRum.addError(err, {
          source: 'deleteDirectSaleableItem',
          type: 'delete-saleable-item',
        });
      });
    },
    updateDirectQty(item, idx) {
      this.payment.directSaleableItems[idx].qty = item.qty;
      // Update cart store
      this.$store.commit('cart/updateDirectStoreItems', {
        saleableItems: this.payment.directSaleableItems
      });
    },

    updateQty(index, item) {
      const rego = this.payment.registrations[index];
      // const product
      // find saleable item
      const foundItemIndex = _.findIndex(rego.saleableItems, (i) => i._id === item._id);
      const regoSummary = this.summary[index];
      const foundSummaryItem = _.findIndex(regoSummary.products, (i) => i._id === item._id);
      if (foundItemIndex > -1) {
        if (rego.saleableItems[foundItemIndex].required && (!item.qty || item.qty === 0)) {
          this.$message.error('You must have at least one item for this registration.');
          rego.saleableItems[foundItemIndex].qty = 1;
          regoSummary.products[foundSummaryItem].qty = 1;
        } else {
          rego.saleableItems[foundItemIndex].qty = item.qty;
          // update cart store
          this.$store.commit('cart/update', {
            index,
            registration: rego
          });
          if (foundSummaryItem > -1) {
            regoSummary.products[foundSummaryItem].qty = item.qty;
            // update total
            regoSummary.products[foundSummaryItem].total = item.qty * rego.saleableItems[foundItemIndex].price;
          }
        }

      // update summary
      }
    },
    noQtyChanged(index, item, itemIndex) {
      const summaryItem = this.originalSummary[index].products[itemIndex];
      return item.qty === summaryItem.qty;
    },
    voucherAvailable(rego) {
      // Don't show for FENCING NSW
      if (this.nationalId === 10) return false;
      if (this.nationalId === 1 && rego.entityLevel === 'club') return false;
      return (!_.find(rego.products, (p) => p.isVoucher === true) && rego.acceptActiveKids && rego.age <= 19);
    },
    additionalVoucherAvailable(rego, index) {
      if (this.nationalId === 10) return false;
      if (this.nationalId === 1 && rego.entityLevel === 'club') return false;
      const r = this.payment.registrations[index];
      if (r.additionalActiveKidsVoucher && r.additionalActiveKidsVoucher.barcode) return false;
      return (_.find(rego.products, (p) => p.isVoucher === true) && rego.acceptActiveKids && rego.age <= 19);
    },
    manualAddress() {
      this.payment.billingAddress.isManual = !this.payment.billingAddress.isManual;
    },
    getTransactionFee(money) {
      const percent = this.$store.getters['cart/transactionFee'];
      if (!percent) {
        const nationalMeta = this.$store.getters['national/getMeta'];
        if (nationalMeta && nationalMeta.transactionFee) {
          return +nationalMeta.transactionFee;
        }
      }
      const preference = this.$store.getters['national/paymentPreference'];
      let fee = 0;
      if (preference.addToTotal >= 0) {
        fee = +((money * preference.addToTotal) / 100).toFixed();
      } else if (!(preference.addToProduct >= 0)) {
        // Only use default total if no product or total setting
        fee = +((money * percent) / 100).toFixed();
      }
      return fee;
    },
    register(token, paymentMethod = 'default') {
      if (this.requirePayment && !token) return;
      this.checkCustomFees();
      if (this.requirePayment && !token) return;
      if (this.requirePayment && !this.checkPayToday()) return;
      this.$store.commit('cart/clearConfirmation');

      const paymentData = {
        registrations: this.payment.registrations,
        cardToken: token,
        paymentTotal: this.payAfter ? this.payTodayTotal : this.totalWithFixedFee,
        payToday: this.cartTotal + this.getTotalFixedTechFee(),
        paymentInstallment: this.payAfter ? (this.cartTotal + this.getTotalFixedTechFee()) : this.totalWithFixedFee,
        paymentMethod,
      };

      // get the payToday for each registration
      this.$http.post('assemble/api/v1/portal/registrations/register', paymentData).then(() => {
        this.$message.success('Successfully registered.');
        this.$store.commit('cart/successful');
        this.$store.commit('cart/clear');
        const pathName = this.hasCustomEntity ? 'custom-success' : 'success';
        this.$router.push({ name: pathName });
        this.$store.commit('loading', false);
      }).catch((err) => {
        datadogRum.addError(err, {
          source: 'register',
          type: 'register',
        });
        const serverError = _.get(err, 'response.data.message');
        this.$store.commit('loading', false);
        this.$message.error({ message: serverError || 'There has been an error', duration: 10000 });
        // if (googleToken) throw new Error(serverError || 'There has been an error');
      });
    },
    async setPayToday() {
      console.log('setPayToday  ', this.summary);
      _.forEach(this.summary, (summary) => {
        let index;
        if (summary.productType === 'team') {
          index = _.findIndex(this.payment.registrations, (registration) => _.get(registration, 'product._id') === summary.productId
        && registration.productType === 'team');
        } else if (summary.productType === 'family') {
          // For family product type, create an ID similar to the summary _id
          index = _.findIndex(this.payment.registrations, (registration) => registration.productType === 'family'
        && `${_.join(_.map(registration.familyRegistrations, (f) => f.memberId), '')}${registration.product._id}` === summary._id);
        } else {
          index = _.findIndex(this.payment.registrations, (registration) => _.get(registration, 'product._id') === summary.productId
        && (_.get(registration, 'memberId') === summary.memberId
         || (registration.memberIds && registration.memberIds.includes(summary.memberId))));
        }
        console.log('index  ', index);
        if (index >= 0) {
          if (summary.payToday !== undefined) {
            // If payToday is already set, use it (payAfter feature)
            this.payment.registrations[index].payToday = summary.payToday;
          } else {
            // Calculate total including registration fee, saleable items, and discounts
            let total = _.get(this.payment.registrations[index], 'product.price', 0);

            // Add saleable items
            const saleableItemsTotal = _.sumBy(this.payment.registrations[index].saleableItems,
              (item) => item.price * item.qty);
            total += saleableItemsTotal;

            // Subtract discounts
            const discounts = this.payment.registrations[index].discounts || [];
            const discountsTotal = _.sumBy(discounts, (discount) => {
              if (discount.type === 'dollar') {
                return discount.amount;
              }
              // Assuming percentage discount
              return (discount.amount / 100) * total;
            });
            total -= discountsTotal;

            // Subtract voucher amounts if any
            if (this.payment.registrations[index].activeKidsVoucher) {
              total -= this.payment.registrations[index].activeKidsVoucher.redeemedAmount;
            }
            if (this.payment.registrations[index].additionalActiveKidsVoucher) {
              total -= this.payment.registrations[index].additionalActiveKidsVoucher.redeemedAmount;
            }
            // Ensure total is not negative
            this.payment.registrations[index].payToday = Math.max(total, 0);
          }
        }
      });
      console.log('this.payment.registrations after  ', this.payment.registrations);
      console.log('this.summary after  ', this.summary);
    },
    transformFamilyToIndvRegistration() {
      const formattedRegistrations = [];
      _.forEach((this.payment.registrations), (r) => {
        if (r.productType === 'family') {
          _.forEach((r.familyRegistrations), (rego, index) => {
            // eslint-disable-next-line no-param-reassign
            rego.product.price = index === 0 ? r.product.price : 0;
            const obj = {
              ...r,
              ...rego,
              memberId: rego.memberId,
              memberType: rego.memberType,
              productId: rego.productId,
              profile: rego.profile,
            };
            formattedRegistrations.push(obj);
          });
        } else {
          formattedRegistrations.push(r);
        }
      });
      return formattedRegistrations;
    },

    executeRegistations(token) {
      this.setPayToday();
      this.$store.commit('cart/clearConfirmation');
      this.$http.post('assemble/api/v1/portal/registrations/register', {
        registrations: this.payment.registrations,
        cardToken: token,
        paymentTotal: this.payAfter ? this.payTodayTotal : this.totalWithFixedFee,
        payToday: this.cartTotal + this.getTotalFixedTechFee(),
        paymentInstallment: this.payAfter ? (this.cartTotal + this.getTotalFixedTechFee()) : this.totalWithFixedFee,
      }).then(() => {
        this.$message.success('Successfully registered.');
        this.$store.commit('cart/successful');
        this.$store.commit('cart/clear');
        const pathName = this.hasCustomEntity ? 'custom-success' : 'success';
        this.$router.push({ name: pathName });
        this.$store.commit('loading', false);
      }).catch((err) => {
        const serverError = _.get(err, 'response.data.message');
        this.$store.commit('loading', false);
        this.$message.error(serverError || 'There has been an error');
      });
    },
    checkCustomFees() {
      _.forEach(this.payment.registrations, (rego) => {
        if (_.get(rego, 'product.customFees.qty') >= 0) {
          const newValue = _.get(rego, 'product.customFees.value') * _.get(rego, 'product.customFees.qty');
          // eslint-disable-next-line no-param-reassign
          rego.product.customFees.value = newValue;
        }
      });
    },

    async pay() {
      const totalWithSaleableItems = _.cloneDeep(this.totalWithSaleableItems);
      const totalDiscount = _.cloneDeep(this.discountTotal);
      this.$store.commit('cart/setIndvCartTotal', { indvCartTotal: this.indvCartTotal, indvPayTodayTotal: this.indvPayTodayTotal });
      this.currentIndvCartTotal = this.indvCartTotal;
      const checkPayTodayTotal = this.checkPayToday();
      if (!checkPayTodayTotal) return;
      // get 2 tokens from pin for registrations and direct saleable items
      await this.setPayToday();
      this.$store.commit('cart/clearConfirmations');
      this.$store.commit('cart/setTotalWithSaleableItems', totalWithSaleableItems);
      this.$store.commit('cart/setTotalDiscount', totalDiscount);

      Promise.all([this.$refs.card && this.$refs.card.validate(), this.$refs.form && this.$refs.form.validate()])
        .then(([cardValid, formValid]) => {
          if (this.requirePayment && (!cardValid || !formValid)) return;
          const teamRegos = _.filter(this.payment.registrations, (r) => r.productType === 'team');

          // if payment is not required || payment total is 0
          if (!this.requirePayment) {
            console.log('Payment not required path taken', {
              requirePayment: this.requirePayment,
              cartTotal: this.cartTotal,
              fixedTechFee: this.getTotalFixedTechFee(),
              payTodayTotal: this.payTodayTotal
            });
            if (teamRegos.length) {
              Promise.all(teamRegos.map((teamRego) => this.registerTeam(undefined, teamRego)))
                .then(() => {
                  this.processingPayment = true;
                })
                .catch((err) => {
                  datadogRum.addError(err, {
                    source: 'registerTeam',
                    type: 'register-team',
                  });
                  this.$message.error(err.message || 'There has been an error registering the teams');
                });
            } else {
              this.processingPayment = true;
            }
            return;
          }

          // Update formatted for isManual
          if (this.payment.billingAddress.isManual) {
            this.payment.billingAddress.formatted = parstAddressFormatted(
              this.payment.billingAddress
            );
          }
          // issue card token
          const [expiryMonth, expiryYear] = this.payment.card.expiry.replace(/\s/g, '').split('/');

          // Create two token promises
          const tokenPromise1 = this.createToken(expiryMonth, expiryYear);
          const tokenPromise2 = this.createToken(expiryMonth, expiryYear);
          let teamTokenPromises = [];
          if (teamRegos.length) {
            teamTokenPromises = teamRegos.map(() => this.createToken(expiryMonth, expiryYear));
          }

          const allTokens = [tokenPromise1, tokenPromise2, ...teamTokenPromises];

          this.$store.commit('loading', { loading: true, text: 'Loading...' });
          Promise.all(allTokens)
            .then(async (tokens) => {
              // Now you have two tokens: token1 and token2
              // You can use them for your registration or whatever you need
              // eslint-disable-next-line prefer-destructuring
              this.token1 = tokens[0];
              // eslint-disable-next-line prefer-destructuring
              this.token2 = tokens[1];
              if (this.requirePayment && !this.token1 && !this.token2) return;
              if (teamRegos.length) {
                try {
                  // Process each team registration with its corresponding token
                  const teamTokens = tokens.slice(2); // Get tokens after token1 and token2
                  const allSuccess = await Promise.all(teamRegos.map((teamRego, index) => this.registerTeam(teamTokens[index], teamRego)));
                  if (allSuccess.every((success) => success)) {
                    this.processingPayment = true;
                  } else {
                    // this.$message.error('There has been an error registering the teams');
                    return;
                  }
                } catch (err) {
                  datadogRum.addError(err, {
                    source: 'registerTeam',
                    type: 'register-team',
                  });
                  this.$message.error(err.message || 'There has been an error registering the teams');
                  return;
                }
              } else {
                this.processingPayment = true;
              }
              this.$store.commit('loading', false);
            })
            .catch((err) => {
              this.$store.commit('loading', false);
              let pinError = _.get(err, 'messages.0.message');
              const pinErrorCode = _.get(err, 'messages.0.code');
              if (pinErrorCode.includes('number') && pinErrorCode.includes('invalid')) {
                pinError = 'Card Number not supported';
              }
              this.$message.error(pinError || 'There has been an error');
            });
        }).catch(() => {});
    },
    async registerTeam(token, teamRego) {
      this.checkCustomFees();
      const checkOutDiscounts = _.filter(this.regoDiscounts, (discount) => discount.type === 'checkoutTotal');
      if (this.requirePayment && !token) return false;
      // this.$store.commit('cart/clearConfirmation');
      this.$store.commit('loading', { loading: true, text: 'Loading...' });
      try {
        const res = await this.$http.post('assemble/api/v1/portal/registrations/register/event-team', {
          noNewTeam: teamRego.existingTeam,
          registration: teamRego,
          cardToken: token,
          paymentTotal: this.getTeamCartTotal(teamRego),
          paymentInstallment: this.getTeamTotal(teamRego),
          discountCode: this.payment.discountCode,
          discountVouchers: this.regoDiscounts.filter((d) => d.productIds.includes(teamRego.product._id)),
          checkOutDiscounts,
        });

        this.$message.success('Successfully registered your team, registering members now.');
        const confirmationData = {
          ...teamRego,
          regoLinks: _.get(res, 'data.data.regoLinks'),
          teamMembers: _.get(res, 'data.data.teamMembers'),
          teamCode: _.get(res, 'data.data.teamCode'),
          payToday: this.teamCartTotal,
        };
        const teamId = _.get(res, 'data.data.teamId');
        const indvToTeamRegoIndex = this.payment.registrations.findIndex((r) => r.productType === 'indv-to-team' && r.team && r.team.name === teamRego.team.name);
        if (indvToTeamRegoIndex > -1) {
          this.$set(this.payment.registrations[indvToTeamRegoIndex].team, '_id', teamId);
        }
        this.$store.commit('cart/setConfirmation', confirmationData);
        // remove team rego from payment
        this.$store.commit('cart/clearTeam');
        // this.$store.commit('cart/clearCart');
        // const pathName = this.hasCustomEntity ? 'custom-success' : 'success';
        // this.$router.push({ name: pathName, params: { confirmationData } });
        this.$store.commit('loading', false);
      } catch (err) {
        datadogRum.addError(err, {
          source: 'registerTeam',
          type: 'register-team',
        });
        const serverError = _.get(err, 'response.data.message');
        this.$store.commit('loading', false);
        this.$message.error(serverError || 'There has been an error');
        return false;
      }

      return true;
    },
    getTeamTotal(teamRego) {
      const rego = _.find(this.summary, (s) => s.teamName === teamRego.team.name);
      let total = 0;
      if (rego && rego.payAfter && rego.payToday > 0) {
        total += rego.payToday;
      } else if (rego && !rego.payLater) {
        total += rego.total;
      }

      return total;
    },
    getTeamCartTotal(teamRego) {
      const total = this.getTeamTotal(teamRego);
      const percent = this.$store.getters['cart/transactionFee'];
      const preference = this.$store.getters['national/paymentPreference'];
      let fee = 0;
      if (preference.addToTotal >= 0) {
        fee = +((total * preference.addToTotal) / 100).toFixed();
      } else if (!(preference.addToProduct >= 0)) {
        fee = +((total * percent) / 100).toFixed();
      }

      // Add fixed tech fee for team registrations (one fee per team)
      const fixedTechFee = this.fixedTechFee && this.fixedTechFee.enabled ? (this.fixedTechFee.amount * 100) : 0;

      return total + fee + fixedTechFee;
    },
    createToken(expiryMonth, expiryYear) {
      return this.pin.createCardToken({
        number: this.payment.card.number,
        name: this.payment.card.name,
        expiry_month: expiryMonth,
        expiry_year: expiryYear,
        cvc: this.payment.card.cvc,
        address_line1: this.payment.billingAddress.addressLine1,
        address_line2: this.payment.billingAddress.addressLine2 || '',
        address_city: this.payment.billingAddress.suburb,
        address_state: this.payment.billingAddress.state,
        address_postcode: this.payment.billingAddress.postcode,
        address_country: 'Australia',
      }).then((pinResponse) => {
        const { issuing_country } = pinResponse;

        console.log('issuing_country', issuing_country);
        if (!['AU', 'NZ'].includes(issuing_country) && [14, 18].includes(+process.env.VUE_APP_NATIONAL_ID)) {
          this.$store.commit('loading', false);
          this.$message.error('International cards are not supported.');
          Promise.reject(new Error('International cards are not supported.'));
          return false;
        }

        const { token, } = pinResponse;
        if (!token) {
          throw new Error('Token generation failed');
        }
        return token;
      }).catch((err) => {
        datadogRum.addError(err, {
          source: 'createToken',
          type: 'create-token',
        });
        throw err;
      });
    },
    async discountCodeCheck(discountIndex, code) {
      try {
        // Collect entityType and entityId from all registrations
        const entities = this.payment.registrations.map((rego) => ({
          entityType: rego.entityType,
          entityId: rego.entityId
        }));

        const res = await this.$http.post('/assemble/api/v1/portal/discount-codes/redeem-check-point', {
          code,
          entities
        });

        const discount = _.get(res, 'data.data.discount');
        const entityRestriction = _.get(res, 'data.data.entityRestriction');
        if (!discount) {
          return false;
        }

        // Store entityRestriction for use in discount application
        this.entityRestriction = entityRestriction;

        if (discount) this.productCheck(discountIndex, discount);
        this.discountId = _.get(this, `regoDiscounts[${discountIndex}]._id`);
        return res.data.data;
      } catch (error) {
        console.log('error:', error);
        const message = _.get(error, 'response.data.message');
        this.regoDiscounts[discountIndex].discountVoucher.error = message;
      }

      return true;
    },
    productCheck(discountIndex, discount) {
      const { entityId, limit, totalLimit } = discount;
      const { registrations } = this.payment;

      const filterRego = _.filter(registrations, (rego) => _.includes(entityId, rego.entityId));
      if (limit >= totalLimit) {
        // eslint-disable-next-line no-param-reassign
        this.regoDiscounts[discountIndex].discountVoucher.error = 'Discount code already exceeds limit';
        return;
      }
      // console.log({
      //   method: 'productCheck',
      //   discount,
      //   discountIndex,
      //   filterRego,
      //   filterRegoLength: filterRego.length,
      //   filterRegoLengthPlusLimit: filterRego.length + limit,
      //   limit,
      //   totalLimit,
      // });

      const campaignDiscountType = _.get(discount, 'campaignDiscountType');
      if (campaignDiscountType === 'entity') {
        // --------------------------------------
        if (discount && discount.campaignDiscountType === 'checkoutTotal') {
          if (limit === totalLimit) {
            this.regoDiscounts[discountIndex].discountVoucher.error = 'Discount code already exceeds limit';
            return;
          }

          // Check entity restrictions for checkout total discounts
          if (this.entityRestriction && this.entityRestriction.requiredEntity) {
            const { requiredEntity } = this.entityRestriction;
            const eligibleTotal = this.calculateEntitySpecificTotal(requiredEntity.sourceEntity);

            if (eligibleTotal === 0) {
              this.regoDiscounts[discountIndex].discountVoucher.error = this.entityRestriction.message || 'This discount code is not applicable to any items in your cart';
              return;
            }
          }

          this.applyDiscountToTotal(discountIndex, discount);
          return;
        }
        // --------------------------------------

        // Check if no products match the discount criteria
        if (filterRego.length === 0) {
          this.regoDiscounts[discountIndex].discountVoucher.error = 'The discount code you are applying is not available for the selected products, please contact your administrator.';
          return;
        }

        // --------------------------------------
        this.limit = totalLimit - limit;
        this.availableProducts = filterRego;
        const productsObj = {};
        filterRego.forEach((rego) => {
          const key = this.getRegoUniqueKey(rego);
          productsObj[key] = false;
        });
        this.productsForDiscount = productsObj;
        this.productsDialogVisible = true;
        // --------------------------------------
        return;
      }

      if (filterRego.length + limit > totalLimit) {
        // Check if no products match the discount criteria
        if (filterRego.length === 0) {
          this.regoDiscounts[discountIndex].discountVoucher.error = 'The discount code you are applying is not available for the selected products, please contact your administrator.';
          return;
        }

        this.limit = totalLimit - limit;
        this.availableProducts = filterRego;
        const productsObj = {};
        filterRego.forEach((rego) => {
          const key = this.getRegoUniqueKey(rego);
          productsObj[key] = false;
        });
        this.productsForDiscount = productsObj;
        this.productsDialogVisible = true;
      } else if (discount && discount.campaignDiscountType === 'checkoutTotal') {
        if (limit === totalLimit) {
          this.regoDiscounts[discountIndex].discountVoucher.error = 'Discount code already exceeds limit';
          return;
        }

        // Check entity restrictions for checkout total discounts
        if (this.entityRestriction && this.entityRestriction.requiredEntity) {
          const { requiredEntity } = this.entityRestriction;
          const eligibleTotal = this.calculateEntitySpecificTotal(requiredEntity.sourceEntity);

          if (eligibleTotal === 0) {
            this.regoDiscounts[discountIndex].discountVoucher.error = this.entityRestriction.message || 'This discount code is not applicable to any items in your cart';
            return;
          }
        }

        this.applyDiscountToTotal(discountIndex, discount);
      } else this.applyDiscountToEntity(discountIndex);
      // applyDiscountToSelectedEntity
    },
    regoSelected(val, rego) {
      const _id = this.getRegoUniqueKey(rego);
      if (val) {
        if (!_.includes(this.selectedRegos, _id)) this.selectedRegos.push(_id);
      } else {
        const removedId = _.filter(this.selectedRegos, (discount) => discount !== _id);
        this.selectedRegos = removedId;
      }
    },
    checkDiscountLimit(rego) {
      const id = this.getRegoUniqueKey(rego);
      // const discountIndex = _.findIndex(this.regoDiscounts, (discount) => discount._id === this.discountId);
      // const { code } = this.regoDiscounts[discountIndex].discountVoucher;
      // console.log({
      //   rego,
      //   selectedProductCount: this.selectedProductCount,
      //   limit: this.limit,
      //   selectedRegos: this.selectedRegos,
      //   id,
      //   codesInUsed: this.$store.getters['cart/codesInUsed'],
      //   regoDiscounts: this.$store.getters['cart/regoDiscounts'],
      //   regoDiscounts2: this.regoDiscounts,
      //   redeemLoading: this.redeemLoading,
      //   productsForDiscount: this.productsForDiscount,
      //   discountId: this.discountId,
      //   code,
      //   cond: this.selectedProductCount >= this.limit && !this.selectedRegos.includes(id),
      // });
      const regoDetails = this.codeRegoDetails;
      const regoDiscountVouchers = _.get(rego, 'discountVoucher', []);
      const regoDiscountVoucherName = _.map(regoDiscountVouchers, 'name');
      const resVoucherName = _.get(regoDetails, 'name', '');
      const hasName = _.includes(regoDiscountVoucherName, resVoucherName);
      return (this.selectedProductCount >= this.limit && !this.selectedRegos.includes(id)) || hasName;
      // return this.selectedProductCount >= this.limit && !this.selectedRegos.includes(id);
    },
    handleRegoSelectionClose() {
      this.selectedRegos = [];
      this.productsDialogVisible = false;
    },
    memberDetails(rego) {
      const selectedBulkMembers = this.$store.getters['cart/selectedBulkMembers'];
      const memberDetails = selectedBulkMembers.filter((member) => rego.memberIds.includes(member._id));
      return memberDetails;
    },
    removeMember(rego, memberId) {
      this.$confirm('Are you sure you want to remove this member?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning'
      }).then(() => {
        const regoIndex = this.payment.registrations.findIndex((r) => r.product._id === rego.productId);
        if (regoIndex !== -1) {
          const memberIndex = this.payment.registrations[regoIndex].memberIds.findIndex((id) => id === memberId);
          if (memberIndex !== -1) {
            this.payment.registrations[regoIndex].memberIds.splice(memberIndex, 1);
            this.$store.commit('cart/updateRego', { regoIndex, memberId });
            this.$set(this.payment.registrations, regoIndex, { ...this.payment.registrations[regoIndex] }); // Ensure reactivity

            this.updateSummary(); // Ensure Vue reactivity updates the summary
            this.$forceUpdate();
          }
        }
      }).catch(() => {});
    },
    updateSummary() {
      this.summary = this.payment.registrations.map((r) => {
        const products = [
          {
            name: `${r.product.price > 0 ? 'Registration Fee' : 'Registration'}`,
            qty: r.memberIds.length,
            total: this.getTotalWithTransactionFee(r.product.price),
            price: r.product.price,
            subProducts: r.subProducts
          }
        ];
        // Add custom fees if rego has one
        if (r.product.customFees && r.product.customFees.value > 0) {
          const qty = r.product.customFees.qty || 1;
          products.push({
            name: r.product.customFees.label === '' ? 'Custom Fee' : r.product.customFees.label,
            qty,
            feeRequired: r.product.customFees.required === undefined ? true : r.product.customFees.required,
            isCustomFees: true,
            price: r.product.customFees.value,
            total: this.getTotalWithTransactionFee(r.product.customFees.value * qty),
          });
        }
        let productTotal = products.reduce((acc, p) => acc + p.total, 0);
        if (r.upgradeFromMembership) {
          let feePaid = r.upgradeFromMembership.pricing.membership.price;
          if (feePaid > productTotal) feePaid = productTotal;
          products.push({
            name: 'Membership Upgrade',
            description: `Upgrade from ${r.upgradeFromMembership.regoEntity.name}`,
            qty: 1,
            total: -feePaid,
          });
        }

        r.saleableItems.forEach((i) => {
          if (i.qty > 0) {
            products.push({
              name: i.name,
              description: i.description,
              isSaleableItem: true,
              price: i.price,
              _id: i._id,
              qty: i.qty,
              total: this.getTotalWithTransactionFee(i.price * i.qty),
            });
          }
        });

        productTotal = products.reduce((acc, p) => acc + p.total, 0);

        if (r.activeKidsVoucher) {
          products.push({
            name: 'Active Kids Voucher',
            description: '',
            qty: 1,
            total: -r.activeKidsVoucher.redeemedAmount,
            isVoucher: true
          });
        }

        if (r.additionalActiveKidsVoucher) {
          products.push({
            name: 'Additional Active Kids Voucher',
            description: '',
            qty: 1,
            total: -r.additionalActiveKidsVoucher.redeemedAmount,
            isVoucher: true
          });
        }

        r.discounts.forEach((i) => {
          let redeemedAmount = 0;
          let balanceAmount;
          console.log('discount item:', i);
          if (i.isSaleableItem && i.isActive) {
            const foundItemIndex = _.findIndex(r.saleableItems, (s) => s._id === i.saleableItem);
            if (foundItemIndex > -1) {
              balanceAmount = this.getTotalWithTransactionFee(r.saleableItems[foundItemIndex].price) * r.saleableItems[foundItemIndex].qty;
              redeemedAmount = i.type === 'dollar' ? i.amount : ((i.amount * balanceAmount) / 100);
              if (redeemedAmount > balanceAmount) redeemedAmount = balanceAmount;
              balanceAmount -= redeemedAmount;
              products.push({
                name: i.name,
                description: i.description,
                qty: i.qty,
                total: -redeemedAmount,
                isDiscount: true
              });
            }
          } else if (i.isRegistration && i.isActive) {
            const saleableItemTotal = _.sumBy(r.saleableItems, (item) => this.getTotalWithTransactionFee(item.price) * item.qty);
            balanceAmount = Math.abs(productTotal - saleableItemTotal);
            redeemedAmount = i.type === 'dollar' ? i.amount : ((i.amount * balanceAmount) / 100);
            if (redeemedAmount > balanceAmount) redeemedAmount = balanceAmount;
            balanceAmount -= redeemedAmount;
            products.push({
              name: i.name,
              description: i.description,
              qty: i.qty,
              total: -redeemedAmount,
              isDiscount: true
            });
          } else if (i.isMultiRegoDiscount) {
            // Handle multi-registration discounts
            balanceAmount = productTotal;

            if (i.isSaleableItem) {
              // Find the specific saleable item this discount applies to
              const saleableItem = _.find(r.saleableItems, (s) => s._id === i.saleableItem);
              if (saleableItem) {
                balanceAmount = this.getTotalWithTransactionFee(saleableItem.price * saleableItem.qty);
              }
            }

            redeemedAmount = i.type === 'dollar' ? i.amount : ((i.amount * balanceAmount) / 100);
            if (redeemedAmount > balanceAmount) redeemedAmount = balanceAmount;

            products.push({
              name: i.name || 'Multiple Registration Discount',
              description: i.description || '',
              qty: 1,
              total: -redeemedAmount,
              isDiscount: true,
              isMultiRegoDiscount: true
            });
          } else if (i.isActive) {
            // Default case for other types of active discounts
            balanceAmount = productTotal;
            redeemedAmount = i.type === 'dollar' ? i.amount : ((i.amount * balanceAmount) / 100);
            if (redeemedAmount > balanceAmount) redeemedAmount = balanceAmount;
            balanceAmount -= redeemedAmount;
            products.push({
              name: i.name,
              description: i.description,
              qty: i.qty,
              total: -redeemedAmount,
              isDiscount: true
            });
          }
        });

        if (r.discountVoucher && r.discountVoucher.length) {
          r.discountVoucher.forEach((voucher) => {
            products.push({
              name: voucher.name,
              description: voucher.description,
              qty: 1,
              total: -voucher.redeemedAmount,
              isDiscount: true,
              voucherType: voucher.voucherType,
            });
          });
        }

        productTotal = products.reduce((acc, p) => acc + p.total, 0);

        // Ensure pay-today is always clamped to the latest total for pay-after regs
        const isPayAfter = r.product.payAfter === true;
        let derivedPayToday = typeof r.payToday === 'number' ? r.payToday : 0;
        if (isPayAfter) {
          if (derivedPayToday > productTotal) derivedPayToday = productTotal;
          // Mirror back to registration so store remains canonical
          // eslint-disable-next-line no-param-reassign
          r.payToday = derivedPayToday;
        }

        return {
          _id: `${r.memberId}${r.product._id}`,
          playerName: `${r.profile.firstName} ${r.profile.lastName}`,
          entityName: r.product.name || r.entityName,
          registrationType: r.entityType,
          entityLevel: r.entityLevel,
          productType: r.productType,
          memberType: r.memberType,
          tags: r.tags,
          products,
          voucherPin: moment(r.profile.dob).format('DDMM'),
          age: calculateMemberAge(r.profile.dob, this.endOfYear),
          total: products.reduce((acc, p) => acc + p.total, 0),
          payAfter: r.product.payAfter,
          // Ensure payToday is present and clamped so v-model is reactive and in range
          payToday: isPayAfter ? derivedPayToday : 0,
          minPrice: r.product.minPrice,
          donation: r.product.donation,
          acceptActiveKids: r.acceptActiveKids === true,
          teamName: r.team ? r.team.name : '',
          redeem: r.redeem,
          discountVoucher: [r.discountVoucher],
          allowPayLater: r.product.allowPayLater,
          payLater: false,
          productId: r.product._id,
          memberIds: r.memberIds,
          isBulk: r.isBulk,
        };
      });
      // Force Vue to detect the changes
      this.$nextTick(() => {
        this.summary = [...this.summary];
        this.$forceUpdate();
      });
    },
    calculateIndvCartTotal() {
      let total = 0;
      const regos = _.filter(this.summary, (i) => i.productType === 'indv' || i.productType === 'indv-to-team' || i.productType === 'family');
      _.forEach(regos, (i) => {
        if (i.payAfter && i.payToday > 0) {
          total += i.payToday;
        } else if (!i.payLater) {
          _.forEach(i.products, (p) => {
            total += p.total;
          });
        }
      });
      if (regos.every((i) => i.payAfter && i.payToday === 0)) return 0;
      return total > 0 ? total : 0;
    },
    resetDiscountCodes() {
      this.regoDiscounts = [
        {
          _id: Math.floor(100000 + Math.random() * 900000),
          discountVoucher: {
            error: '',
            code: '',
            redeemed: false
          },
          productIds: [],
        }
      ];
    }
  },
  computed: {
    ...mapGetters('national', ['endOfYear']),
    hasCustomEntity() {
      const customEntity = this.$store.getters['national/getEntity'];
      if (customEntity && customEntity.level && customEntity.name) {
        return true;
      }
      return false;
    },
    isNotFirefox() {
      return navigator.userAgent.toLowerCase().indexOf('firefox') === -1;
    },
    canShowApplePay() {
      return window.ApplePaySession && window.ApplePaySession.canMakePayments();
    },
    applePayOptions() {
      return {
        countryCode: 'AU',
        currencyCode: 'AUD',
        total: {
          label: 'Pay & Register',
          amount: this.total / 100,
        },
        supportedNetworks: ['masterCard', 'visa'],
        merchantCapabilities: ['supports3DS', 'supportsCredit', 'supportsDebit']
      };
    },
    googlePayOptions() {
      return {
        ...this.options,
        transactionInfo: {
          totalPriceStatus: 'FINAL',
          totalPrice: this.total,
          currencyCode: 'AUD',
          countryCode: 'AU'
        },
      };
    },
    // ...mapGetters('cart', ['registrations']),
    feePercentage() {
      let defaultFee = this.$store.getters['cart/transactionFee'];
      if (!defaultFee) {
        const nationalMeta = this.$store.getters['national/getMeta'];
        if (nationalMeta && nationalMeta.transactionFee) {
          defaultFee = +nationalMeta.transactionFee;
        }
      }
      const preference = this.$store.getters['national/paymentPreference'];
      const { addToTotal } = preference;
      return addToTotal >= 0 ? addToTotal : defaultFee;
    },
    minPayment() {
      const minPayment = _.get(this, 'registrations[0].product.minPrice', 0);
      const { cartTotal } = this;
      return Math.min(minPayment, cartTotal);
    },
    currentDiscounts() {
      return this.$store.getters['cart/regoDiscounts'];
    },
    registrations() {
      return this.$store.getters['cart/registrations'];
    },
    directSaleableItems() {
      // console.log({
      //   directSaleableItems: this.$store.getters['cart/directSaleableItems']
      // });
      return this.$store.getters['cart/directSaleableItems'];
    },
    national() {
      return +process.env.VUE_APP_NATIONAL_ID;
    },
    discountTotal() {
      let total = 0;
      _.forEach(this.summary, (i) => {
        total += _.sumBy(i.products, (x) => (x.isDiscount ? x.total : 0));
      });

      // checkout total discount
      return total + (-this.totalDiscount);
    },
    cartTotal() {
      const total = this.calculateCartTotal();
      console.log('cartTotal calculated:', total);
      // console.log('Cart Total 1');
      if (this.lastCartTotal !== total) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.lastCartTotal = total;
        // const { transactionFee } = this;
        // console.log('Cart Total 2');
        // Add a guard to prevent recursive recalculation
        if (!this.isRecalculatingDiscounts) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.isRecalculatingDiscounts = true;
          // this.recalculateRegoDiscounts(total, transactionFee);
          // console.log('Cart Total 3 --- Recalculation');
          this.$nextTick(() => {
            this.isRecalculatingDiscounts = false;
          });
        }
      }

      // Don't return 0 for payAfter with payToday === 0 as it breaks fixed fee calculations
      // if (this.summary.every((i) => i.payAfter && i.payToday === 0)) return 0;
      console.log('cartTotal returning:', total);
      return total;
    },
    indvCartTotal() {
      const result = this.summary.reduce((total, rego) => {
        if (rego.productType === 'indv' || rego.productType === 'indv-to-team' || rego.productType === 'family') {
          if (rego.payAfter && rego.payToday > 0) {
            return total + rego.payToday;
          }
          if (rego.payAfter && rego.payToday === 0) {
            return total + 0;
          }
          if (!rego.payLater) {
            const productTotal = rego.products.reduce((sum, p) => sum + p.total, 0);
            return total + productTotal;
          }
        }
        return total;
      }, 0);
      return result;
    },
    teamCartTotal() {
      let total = 0;
      const rego = _.find(this.summary, (i) => i.productType === 'team');
      if (rego && rego.payAfter && rego.payToday > 0) {
        total += rego.payToday;
      } else if (rego && !rego.payLater) {
        total += rego.total;
      }
      return total;
    },
    saleableItemTotal() {
      let total = 0;
      _.forEach(this.payment.directSaleableItems, (i) => {
        total += i.price * i.qty;
      });
      return total;
    },
    allCartTotal() {
      return this.cartTotal + this.saleableItemTotal;
    },
    transactionFee() {
      let percent = this.$store.getters['cart/transactionFee'];
      if (!percent) {
        const nationalMeta = this.$store.getters['national/getMeta'];
        if (nationalMeta && nationalMeta.transactionFee) {
          percent = +nationalMeta.transactionFee;
        }
      }
      const preference = this.$store.getters['national/paymentPreference'];
      let fee = 0;
      // if ((preference.addToTotal === 0 && preference.addToProduct === 0)) return 0;
      if (preference.addToTotal >= 0) {
        fee = +((this.cartTotal * preference.addToTotal) / 100).toFixed();
      } else if (!(preference.addToProduct >= 0)) {
        // Only use default total if no product or total setting
        fee = +((this.cartTotal * percent) / 100).toFixed();
      }
      return fee;
    },
    indvTransactionFee() {
      const percent = this.$store.getters['cart/transactionFee'];
      const preference = this.$store.getters['national/paymentPreference'];
      let fee = 0;
      if (preference.addToTotal >= 0) {
        fee = +((this.indvCartTotal * preference.addToTotal) / 100).toFixed();
      } else if (!(preference.addToProduct >= 0)) {
        fee = +((this.indvCartTotal * percent) / 100).toFixed();
      }
      return fee;
    },
    teamTransactionFee() {
      const percent = this.$store.getters['cart/transactionFee'];
      const preference = this.$store.getters['national/paymentPreference'];
      let fee = 0;
      if (preference.addToTotal >= 0) {
        fee = +((this.teamCartTotal * preference.addToTotal) / 100).toFixed();
      } else if (!(preference.addToProduct >= 0)) {
        fee = +((this.teamCartTotal * percent) / 100).toFixed();
      }
      return fee;
    },
    saleableItemTransactionFee() {
      let percent = this.$store.getters['cart/transactionFee'];
      if (!percent) {
        const nationalMeta = this.$store.getters['national/getMeta'];
        if (nationalMeta && nationalMeta.transactionFee) {
          percent = +nationalMeta.transactionFee;
        }
      }
      const preference = this.$store.getters['national/paymentPreference'];
      let fee = 0;
      if (preference.addToTotal >= 0) {
        fee = +((this.saleableItemTotal * preference.addToTotal) / 100).toFixed();
      } else if (!(preference.addToProduct >= 0)) {
        // Only use default total if no product or total setting
        fee = +((this.saleableItemTotal * percent) / 100).toFixed();
      }
      return fee;
    },
    total() {
      const total = +(this.cartTotal + this.transactionFee - this.totalDiscount).toFixed();
      return total;
    },
    totalWithFixedFee() {
      return this.total + this.getTotalFixedTechFee();
    },
    indvTotal() {
      return +((this.indvCartTotal + this.indvTransactionFee) - this.totalDiscount).toFixed();
    },

    teamTotal() {
      return +((this.teamCartTotal + this.teamTransactionFee) - this.totalDiscount).toFixed();
    },
    totalSaleableItemsWithFee() {
      return this.saleableItemTotal + this.saleableItemTransactionFee;
    },
    totalWithSaleableItems() {
      return this.total + this.totalSaleableItemsWithFee + this.getTotalFixedTechFee();
    },
    fixedTechFee() {
      return this.$store.getters['national/getFixedTechFee'];
    },

    payTodayTotal() {
      // If cartTotal is 0, don't add any fees for payAfter registrations
      if (this.cartTotal === 0) {
        return 0;
      }
      const result = +(this.cartTotal + this.transactionFee + this.getTotalFixedTechFee());
      return result;
    },
    indvPayTodayTotal() {
      const { indvCartTotal } = this;

      // If indvCartTotal is 0, don't add any fees for payAfter registrations
      if (indvCartTotal === 0) {
        return 0;
      }
      let percent = 0;
      const defaultTransactionFee = this.$store.getters['cart/transactionFee'];
      const preference = this.$store.getters['national/paymentPreference'];
      if (preference && preference.addToTotal >= 0) {
        percent = preference.addToTotal;
      } else {
        percent = defaultTransactionFee;
      }
      return +(indvCartTotal + ((indvCartTotal * percent) / 100) - this.totalDiscount + this.getTotalFixedTechFee()).toFixed();
    },
    requirePayment() {
      const actualFixedTechFee = this.getTotalFixedTechFee();
      const requiresPayment = (this.allCartTotal > 0 || actualFixedTechFee > 0) && !(this.summary.length && this.summary.every((i) => i.payAfter) && this.payTodayTotal === 0);
      return requiresPayment;
    },
    resCol() {
      return this.requirePayment ? {
        xs: 24, sm: 24, md: 12, lg: 12
      } : {
        xs: 24, sm: 24, md: 24, lg: 24
      };
    },
    fillingAddress() {
      const activeMember = this.$store.getters['user/activeMember'];
      const rego = _.head(this.payment.registrations);
      if (_.get(rego, 'profile.address.formatted')) {
        return rego.profile.address;
      } if (activeMember) {
        return activeMember.profile.address;
      }
      return false;
    },
    isPayDisabled() {
      return this.payment.registrations.length === 0 && this.payment.directSaleableItems.length === 0;
    },
    paymentTitle() {
      return this.requirePayment ? 'Payment Details' : 'Complete your registration';
    },
    paymentButtonText() {
      return this.requirePayment ? 'Pay & Complete' : 'Register';
    },
    codesInUsed() {
      return this.$store.getters['cart/codesInUsed'];
    },
    cTotalDiscount() {
      const total = _.find(this.regoDiscounts, (discount) => discount.type === 'checkoutTotal');
      return total;
    },
    selectedProductCount() {
      return this.selectedRegos.length;
    },
  },
  filters: {
    parsePrice(val) {
      const rs = (val / 100).toFixed(2);
      if (val < 0) return `-$${(Math.abs(rs)).toFixed(2)}`;
      return `$${rs}`;
    },
    parseProductType(val) {
      return (_.find(productTypes, (pt) => pt.type === val)).name;
    },
    parseEntityName(val) {
      console.log('team', val);
      return val.productType === 'indv-to-team' ? `${_.get(val, 'teamName', '') ? _.get(val, 'teamName', '') : _.get(val, 'team.name')}, ${val.entityName}` : val.entityName;
    },
    cap(val) {
      return _.capitalize(val);
    },
    joinTag(vals) {
      return _.join(_.map(vals, (v) => v.name), ', ');
    }
  },
  watch: {
    regoDiscounts: {
      immediate: true,
      deep: true,
      handler() {
        const checkouts = _.filter(this.regoDiscounts, (discount) => discount.type === 'checkoutTotal');
        const total = _.sumBy(_.map(checkouts, (checkout) => checkout.discountVoucher), 'redeemedAmount');

        this.totalDiscount = total;
      }
    },
    '$store.state.cart.registrations': {
      immediate: true,
      deep: true,
      // eslint-disable-next-line func-names
      handler: async function (val) {
        const registrations = _.map(val, (re) => _.assign({}, re, {
          redeem: {
            code: undefined,
            redeemed: false,
            error: undefined
          }
        }));
        if (this.payment && this.payment.registrations) {
          this.payment.registrations = registrations;
          await this.setPayToday();
        } else this.$set(this, 'payment.registrations', registrations);
      }
    },
    '$store.state.cart.saleableItems': {
      immediate: true,
      deep: true,
      // eslint-disable-next-line func-names
      handler: function (val) {
        this.payment.directSaleableItems = val;
      }
    },
    // summary: {
    //   immediate: true,
    //   // eslint-disable-next-line object-shorthand, func-names
    //   handler: function (val) {
    //     this.currSummary = val;
    //   }
    // }
    'payment.registrations': {
      immediate: true,
      deep: true,
      handler(val) {
        const payTodayMap = {};
        if (this.summary && this.summary.length) {
          _.forEach(this.summary, (item) => {
            if (item.productId) {
              payTodayMap[item.productId] = item.payToday;
            }
          });
        }
        this.summary = [];
        _.forEach(val, (r) => {
          const products = [
            {
              name: `${_.get(r, 'product.price') > 0 ? 'Registration Fee' : 'Registration'}`,
              qty: r.memberIds && r.memberIds.length ? r.memberIds.length : 1,
              total: this.getTotalWithTransactionFee(_.get(r, 'product.price') * (r.memberIds?.length || 1)),
              price: _.get(r, 'product.price'),
              subProducts: r.subProducts
            }
          ];
          // Add custom fees if rego has one
          if (_.get(r, 'product.customFees') && _.get(r, 'product.customFees.value') > 0) {
            const qty = _.get(r, 'product.customFees.qty', 1);
            products.push({
              name: r.product.customFees.label === '' ? 'Custom Fee' : r.product.customFees.label,
              qty,
              feeRequired: r.product.customFees.required === undefined ? true : _.get(r, 'product.customFees.required', false),
              isCustomFees: true,
              price: r.product.customFees.value,
              total: this.getTotalWithTransactionFee(r.product.customFees.value * qty),
            });
          }
          let productTotal = _.sumBy(products, 'total');
          if (r.upgradeFromMembership) {
            let feePaid = r.upgradeFromMembership.pricing.membership.price;
            if (feePaid > productTotal) feePaid = productTotal;
            products.push({
              name: 'Membership Upgrade',
              description: `Upgrade from ${r.upgradeFromMembership.regoEntity.name}`,
              qty: 1,
              total: -feePaid,
            });
          }

          _.forEach(r.saleableItems, (i) => {
            if (i.qty > 0) {
              products.push({
                name: i.name,
                description: i.description,
                isSaleableItem: true,
                price: i.price,
                _id: i._id,
                qty: i.qty,
                total: this.getTotalWithTransactionFee((i.price * i.qty)),
              });
            }
          });

          productTotal = _.sumBy(products, 'total');

          if (r.activeKidsVoucher) {
            products.push({
              name: 'Active Kids Voucher',
              description: '',
              qty: 1,
              total: -r.activeKidsVoucher.redeemedAmount,
              isVoucher: true
            });
          }

          if (r.additionalActiveKidsVoucher) {
            products.push({
              name: 'Additional Active Kids Voucher',
              description: '',
              qty: 1,
              total: -r.additionalActiveKidsVoucher.redeemedAmount,
              isVoucher: true
            });
          }

          let balanceAmount;
          _.forEach(r.discounts, (i) => {
            let redeemedAmount = 0;
            if (i.isSaleableItem && i.isActive) {
              const foundItemIndex = _.findIndex(r.saleableItems, (s) => s._id === i.saleableItem);
              if (foundItemIndex > -1) {
                balanceAmount = this.getTotalWithTransactionFee(r.saleableItems[foundItemIndex].price) * r.saleableItems[foundItemIndex].qty;
                redeemedAmount = i.type === 'dollar' ? i.amount : ((i.amount * balanceAmount) / 100);
                if (redeemedAmount > balanceAmount) redeemedAmount = balanceAmount;
                balanceAmount -= redeemedAmount;
                products.push({
                  name: i.name,
                  description: i.description,
                  qty: i.qty,
                  total: -redeemedAmount,
                  isDiscount: true
                });
              }
            } else if (i.isRegistration && i.isActive) {
              const saleableItemTotal = _.sumBy(r.saleableItems, (item) => this.getTotalWithTransactionFee(item.price) * item.qty);
              balanceAmount = Math.abs(productTotal - saleableItemTotal);
              redeemedAmount = i.type === 'dollar' ? i.amount : ((i.amount * balanceAmount) / 100);
              if (redeemedAmount > balanceAmount) redeemedAmount = balanceAmount;
              balanceAmount -= redeemedAmount;
              products.push({
                name: i.name,
                description: i.description,
                qty: i.qty,
                total: -redeemedAmount,
                isDiscount: true
              });
            } else if (i.isMultiRegoDiscount) {
              // Handle multi-registration discounts
              balanceAmount = productTotal;

              if (i.isSaleableItem) {
                // Find the specific saleable item this discount applies to
                const saleableItem = _.find(r.saleableItems, (s) => s._id === i.saleableItem);
                if (saleableItem) {
                  balanceAmount = this.getTotalWithTransactionFee(saleableItem.price * saleableItem.qty);
                }
              }

              redeemedAmount = i.type === 'dollar' ? i.amount : ((i.amount * balanceAmount) / 100);
              if (redeemedAmount > balanceAmount) redeemedAmount = balanceAmount;

              products.push({
                name: i.name || 'Multiple Registration Discount',
                description: i.description || '',
                qty: 1,
                total: -redeemedAmount,
                isDiscount: true,
                isMultiRegoDiscount: true
              });
            } else if (i.isActive) {
              // Default case for other types of active discounts
              balanceAmount = productTotal;
              redeemedAmount = i.type === 'dollar' ? i.amount : ((i.amount * balanceAmount) / 100);
              if (redeemedAmount > balanceAmount) redeemedAmount = balanceAmount;
              balanceAmount -= redeemedAmount;
              products.push({
                name: i.name,
                description: i.description,
                qty: i.qty,
                total: -redeemedAmount,
                isDiscount: true
              });
            }
          });

          if (r.discountVoucher && r.discountVoucher.length) {
            _.forEach(r.discountVoucher, (voucher) => {
              products.push({
                name: voucher.name,
                description: voucher.description,
                qty: 1,
                total: -voucher.redeemedAmount,
                isDiscount: true,
                voucherType: voucher.voucherType,
              });
            });
          }

          productTotal = _.sumBy(products, 'total');

          if (r.productType !== 'family' && r.productType !== 'team') {
            const computedTotal = _.sumBy(products, 'total');
            let regoPayToday = 0;
            if (r.product.payAfter === true) {
              regoPayToday = typeof r.payToday === 'number' ? r.payToday : computedTotal;
              // clamp to [min, total]
              const min = _.get(r, 'product.minPrice', 0) || 0;
              if (regoPayToday > computedTotal) regoPayToday = computedTotal;
              if (regoPayToday < min) regoPayToday = min;
              // mirror back to registration for canonical store state
              // eslint-disable-next-line no-param-reassign
              r.payToday = regoPayToday;
            }
            this.summary.push({
              _id: `${r.memberId}${r.product._id}`,
              playerName: `${r.profile.firstName} ${r.profile.lastName}`,
              entityName: r.product.name || r.entityName,
              registrationType: r.entityType,
              entityLevel: r.entityLevel,
              productType: r.productType,
              memberType: r.memberType,
              tags: r.tags,
              products,
              voucherPin: moment(r.profile.dob).format('DDMM'),
              age: calculateMemberAge(r.profile.dob, this.endOfYear),
              total: computedTotal,
              payAfter: r.product.payAfter,
              // payToday: r.payToday || _.sumBy(products, 'total'),
              payToday: regoPayToday,
              minPrice: r.product.minPrice,
              donation: r.product.donation,
              acceptActiveKids: r.acceptActiveKids === true,
              teamName: _.get(r, 'team.name'),
              redeem: r.redeem,
              discountVoucher: [r.discountVoucher],
              allowPayLater: r.product.allowPayLater,
              payLater: r.payLater || false,
              productId: r.product._id,
              memberId: r.memberId,
              memberIds: r.memberIds,
              isBulk: r.isBulk,
              // deprecated field kept for backward compatibility in templates
              // now set above via regoPayToday
              // payTodayLegacy: payTodayMap[r.product._id] || computedTotal,
            });
          } else if (r.productType === 'family') {
            const computedTotal = _.sumBy(products, 'total');
            let regoPayToday = 0;
            if (r.product.payAfter === true) {
              regoPayToday = typeof r.payToday === 'number' ? r.payToday : computedTotal;
              const min = _.get(r, 'product.minPrice', 0) || 0;
              if (regoPayToday > computedTotal) regoPayToday = computedTotal;
              if (regoPayToday < min) regoPayToday = min;
              // eslint-disable-next-line no-param-reassign
              r.payToday = regoPayToday;
            }
            const memberDetails = _.map((r.familyRegistrations), (rego) => ({
              playerName: `${rego.profile.firstName} ${rego.profile.lastName}`,
              age: calculateMemberAge(rego.profile.dob, this.endOfYear),
              memberType: rego.memberType,
            }));

            const familyMemberIds = _.map((r.familyRegistrations), (f) => f.memberId);

            this.summary.push({
              _id: `${_.join(_.map(familyMemberIds, String), '')}${r.product._id}`,
              memberDetails,
              // playerNames: `${r.profile.firstName} ${r.profile.lastName}`,
              entityName: r.product.name || r.entityName,
              registrationType: r.entityType,
              entityLevel: r.entityLevel,
              productType: r.productType,
              // memberType: r.memberType,
              tags: r.tags,
              products,
              // voucherPin: moment(r.profile.dob).format('DDMM'),
              // age: calculateMemberAge(r.profile.dob, this.endOfYear),
              total: computedTotal,
              payAfter: r.product.payAfter,
              allowPayLater: r.product.allowPayLater,
              payLater: r.payLater || false,
              minPrice: r.product.minPrice,
              donation: r.product.donation,
              acceptActiveKids: r.acceptActiveKids === true,
              teamName: _.get(r, 'team.name'),
              redeem: r.redeem,
              discountVoucher: [r.discountVoucher],
              payToday: regoPayToday,
            });
          } else if (r.productType === 'team') {
            const computedTotal = _.sumBy(products, 'total');
            let regoPayToday = 0;
            if (r.product.payAfter === true) {
              regoPayToday = typeof r.payToday === 'number' ? r.payToday : computedTotal;
              const min = _.get(r, 'product.minPrice', 0) || 0;
              if (regoPayToday > computedTotal) regoPayToday = computedTotal;
              if (regoPayToday < min) regoPayToday = min;
              // eslint-disable-next-line no-param-reassign
              r.payToday = regoPayToday;
            }
            this.summary.push({
              teamName: r.team.name,
              ageRange: `${r.product.ageFrom} - ${r.product.ageTo}`,
              productType: r.productType,
              tags: r.tags,
              products,
              allowPayLater: r.product.allowPayLater,
              payLater: false,
              eventName: r.name,
              total: computedTotal,
              payAfter: r.product.payAfter,
              minPrice: r.product.minPrice,
              productId: r.product._id,
              payToday: regoPayToday,
            });
          }
        });
        this.originalSummary = _.cloneDeep(this.summary);
        this.$forceUpdate();
      }
    },

  }
};
</script>

<style lang="scss" scoped>
.qty-input {
  width: 70px !important;
  margin-left: auto;

  ::v-deep input {
    text-align: center;
    padding-right: 5px;
  }
}
::v-deep apple-pay-button {
  --apple-pay-button-width: 150px;
  --apple-pay-button-height: 42px !important;
  --apple-pay-button-border-radius: 6px !important;
  --apple-pay-button-padding: 0px 0px;
  --apple-pay-button-box-sizing: border-box;
}

.vendor-payment {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  justify-content: center;
  &.single {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .vendor-payment {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1rem;
  }
}

.payment-container {
  width: 100%;
  max-width: $lg;

  @media (min-width: 768px) {
    padding: 0 20px;
  }

  @media (min-width: 1024px) {
    padding: 0;
  }
}

.sub-products-list {
  padding-left: 20px;
  margin-top: 10px;
}

.sub-products-title {
  font-weight: bold;
  margin-bottom: 5px;
}

.sub-products-names {
  list-style-type: none;
  padding: 0;
}

.sub-products-names li {
  margin-bottom: 5px;
}

.inline-list {
  list-style-type: none;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;

  li {
    margin-bottom: 5px;
    display: inline;
    margin-right: 10px;
  }
}

::v-deep .el-card__body {
  width: 100%;
  max-width: 100% !important;
}

::v-deep .item-table {
  border: 1px solid rgba(45, 58, 69, 0.1);

  th {
    background: #F6F8FA !important;
    padding: 1em;
    text-align: left;
  }

  td {
    background-color: white !important;
    padding: 0.6em 1em;
  }

  .product-info {
    .name {
      font-size: 1em;
    }
    .keepword {
      word-break: keep-all;
    }

    .description {
      font-size: 0.8em;
      font-family: $fontLight;
    }
  }
}

.title {
  font-weight: bold;
  margin-right: 0.3em;
}

.header {
  font-size: 1.2em;
  font-weight: bold;
  margin-right: 0.3em;
}

.bottomBtn {
  max-width: 100%;
  width: 10em;
}

.payBtn {
  max-width: 100%;
  width: 15em;
}

apple-pay-button {
  --apple-pay-button-width: 150px;
  --apple-pay-button-height: 46px;
  --apple-pay-button-border-radius: 100vh;
  --apple-pay-button-padding: 0px 0px;
  --apple-pay-button-box-sizing: border-box;
  display: initial;
  width: 240px;
  height: 46px !important;
}

.pay-later-wrapper {
  padding: 10px 10px 30px 10px;
  margin-bottom: 10px;
  border-radius: 10px;
  position: relative;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #ccc;
}

.pay-later-selected {
  border-color: #28a745;
}

.pay-later-checkbox {
  position: absolute;
  bottom: 7px;
  right: 10px;
  z-index: 2;
}

.pay-later-text {
  position: absolute;
  bottom: 7px;
  left: 10px;
  z-index: 2;
  color: #2D3A45;
  font-size: 0.9em;
}

.card-container {
  position: relative;
  margin-bottom: 20px;

  @media (max-width: 767px) {
    margin-bottom: 16px;
    margin-left: -8px;
    margin-right: -8px;
  }
}

.card-header {
  padding: 10px;
  background-color: #fff;
  border-bottom: 1px solid #ccc;
}

.card-body-container {
  position: relative;
  padding: 16px;

  @media (max-width: 767px) {
    padding: 12px;
  }
}

.blurred-content {
  filter: blur(3px);
  z-index: 1;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.25);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  pointer-events: none;
  z-index: 2;
}

.overlay-text {
  font-size: 1.5em;
  font-weight: bold;
  z-index: 4;
}

.item-card {
  .el-card__header {
    padding: 12px 16px;
    background-color: #f5f7fa;

    @media (max-width: 767px) {
      padding: 12px 16px;
    }
  }

  @media (max-width: 767px) {
    margin: 0 8px;
    border-radius: 8px;
  }
}

.store-summary-card {
  border-radius: 12px;
  border: 1px solid #e5e7eb;
}

::v-deep .store-summary-card .el-card__body {
  padding: 0 20px 12px 20px;

  @media (max-width: 767px) {
    padding: 0 8px 12px 8px;
  }
}

.store-summary__grid {
  display: grid;
  grid-template-columns: 1.4fr 0.6fr 0.5fr 0.6fr;
  gap: 16px;
  align-items: center;
}

.store-summary__header {
  font-size: 12px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #6b7280;
  font-weight: 600;
  padding: 0 4px;
}

.store-summary__body {
  padding: 8px 0 4px 0;
}

.store-summary__row {
  padding: 16px 4px;
  border-bottom: 1px solid #edf2f7;

  &:last-child {
    border-bottom: none;
  }
}

.store-summary__product {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.store-summary__name {
  font-weight: 600;
  color: #111827;
  font-size: 15px;
}

.store-summary__field-label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #9ca3af;
  font-weight: 600;
  display: none;
}

.store-summary__value {
  font-weight: 600;
  color: #111827;
  font-size: 15px;
}

.store-summary__price,
.store-summary__qty,
.store-summary__total {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.store-summary__price {
  align-items: flex-start;
}

.store-summary__qty {
  align-items: flex-start;
  width: 100%;

  ::v-deep .el-qty-input {
    width: 56px;
    margin-left: auto;
  }
}

.store-summary__total {
  align-items: flex-end;
}

.store-summary__total-line {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  width: 100%;
  align-items: center;
}

.store-summary__row-actions {
  display: flex;
  gap: 4px;
  padding-top: 6px;
  border-top: 1px dashed #e5e7eb;
  width: 100%;
  justify-content: flex-end;

  .el-button {
    padding: 0 4px;
  }
}

@media (max-width: 1023px) {
  .store-summary__grid {
    grid-template-columns: 1fr 0.5fr 0.5fr 0.6fr;
  }
}

@media (max-width: 767px) {
  .store-summary__header {
    display: none;
  }

  .store-summary__grid {
    grid-template-columns: 1fr;
  }

  .store-summary__row {
    padding: 16px 0;
    gap: 10px;
  }

  .store-summary__price,
  .store-summary__qty {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 200px;
    width: 100%;
  }

  .store-summary__field-label {
    display: block;
  }

  .store-summary__qty {
    ::v-deep .el-qty-input {
      width: 80px;
    }
  }

  .store-summary__total {
    width: 100%;
    align-items: flex-start;
    gap: 8px;

    .store-summary__total-line {
      justify-content: space-between;
    }

    .store-summary__row-actions {
      justify-content: flex-start;
    }
  }
}

.header-label {
  font-weight: bold;
}

.desktop-view {
  @media (max-width: 767px) {
    display: none;
  }

  .product-actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 5px;
  }
}

.mobile-view {
  display: none;
  @media (max-width: 767px) {
    display: block;
  }

  .product-header {
    font-weight: bold;
    font-size: 1.1em;
    margin-bottom: 10px;
  }

  .product-details {
    .detail-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;

      .detail-label {
        font-weight: bold;
      }

      .detail-value {
        text-align: right;
      }
      .qty-input {
    width: 80px !important;
    margin-left: auto;

    ::v-deep input {
      text-align: center;
      padding-right: 5px;
    }

    ::v-deep .el-input-number__decrease,
    ::v-deep .el-input-number__increase {
      width: 20px;
    }
  }
    }
  }

  .product-actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
  }
}

// Discount Selection Dialog Styles
::v-deep .discount-selection-dialog {
  .el-dialog {
    width: 95% !important;
    border-radius: 12px;
    overflow: hidden;

    @media (min-width: 768px) {
      width: 70% !important;
    }

    @media (min-width: 1024px) {
      width: 60% !important;
    }
  }

  .el-dialog__header {
    background: white;
    border-bottom: 1px solid #e2e8f0;
    padding: 20px 24px;
    margin: 0;

    .el-dialog__title {
      font-size: 18px;
      font-weight: 600;
      color: #001F5B;
    }

    .el-dialog__close {
      color: #606266;
      font-size: 18px;

      &:hover {
        color: #001F5B;
      }
    }
  }

  .el-dialog__body {
    padding: 20px 16px;
    background-color: #f8fafc;

    @media (min-width: 768px) {
      padding: 24px 32px;
    }
  }

  .dialog-content {
    .selection-header {
      margin-bottom: 24px;

      .selection-alert {
        border-radius: 6px;
        border: 1px solid transparent;

        &.el-alert--info {
          background: #f0f9ff;
          border-color: #bfdbfe;
          color: #001F5B;
        }

        &.el-alert--error {
          background: #fef2f2;
          border-color: #fecaca;
          color: #dc2626;
        }

        .alert-content {
          display: flex;
          align-items: center;
          font-weight: 500;
          font-size: 14px;

          i {
            font-size: 16px;
            margin-right: 8px;
          }
        }
      }
    }

    .registrations-list {
      max-height: 55vh;
      overflow-y: auto;
      padding: 5px 8px 0 0;

      /* Custom scrollbar */
      &::-webkit-scrollbar {
        width: 6px;
      }

      &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 3px;
      }

      &::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 3px;

        &:hover {
          background: #a8a8a8;
        }
      }

      .registration-card {
        margin-bottom: 16px;
        .rego-card {
          border-radius: 8px;
          transition: all 0.2s ease;
          border: 1px solid #e2e8f0;
          background: white;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

          &:hover {
            border-color: #001F5B;
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0, 31, 91, 0.15);
          }

          .card-header {
            background: #f8fafc;
            border-bottom: 1px solid #e2e8f0;
            padding: 12px;
            margin: 0;
            border-radius: 8px 8px 0 0;

            @media (min-width: 768px) {
              padding: 16px;
            }

            .registration-info {
              .entity-name {
                margin: 0 0 12px 0;
                color: #001F5B;
                font-size: 16px;
                font-weight: 600;
              }

              .registration-meta {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                gap: 6px;

                .el-tag {
                  border-radius: 4px;
                  font-size: 12px;
                  font-weight: 500;
                  border: none;

                  &.el-tag--info {
                    background: #001F5B;
                    color: white;
                  }

                  &.el-tag--warning {
                    background: #f59e0b;
                    color: white;
                  }

                  &.el-tag--success {
                    background: #10b981;
                    color: white;
                  }

                  i {
                    margin-right: 4px;
                  }
                }
              }
            }
          }

          .card-body {
            padding: 15px;

            @media (min-width: 768px) {
              padding: 20px;
            }

            .member-details {
              .member-name {
                display: flex;
                align-items: center;
                font-size: 14px;
                font-weight: 500;
                color: #606266;
                margin-bottom: 8px;

                i {
                  color: #909399;
                }
              }

              .member-type {
                font-size: 13px;
                color: #909399;

                .label {
                  font-weight: 500;
                  margin-right: 8px;
                }

                .value {
                  color: #606266;
                }
              }
            }

            .family-members {
              .members-title {
                display: flex;
                align-items: center;
                margin: 0 0 12px 0;
                font-size: 14px;
                font-weight: 600;
                color: #303133;

                i {
                  color: #409eff;
                }
              }

              .members-table {
                .el-table th {
                  background-color: #fafafa;
                }
              }
            }
          }

          .card-footer {
            border-top: 1px solid #f0f0f0;
            padding-top: 12px;
            margin-top: 12px;

            .selection-checkbox {
              width: 100%;

              .checkbox-label {
                font-weight: 500;
                color: #606266;
                margin-left: 8px;
              }

              &.is-checked .checkbox-label {
                color: #409eff;
              }

              &.is-disabled .checkbox-label {
                color: #c0c4cc;
              }
            }
          }

          &.family-card {
            .card-body {
              padding-top: 0;
            }
          }
        }
      }
    }

    .dialog-actions {
      background: white;
      border-top: 2px solid #e2e8f0;
      display: flex;
      gap: 12px;
      border-radius: 0 0 12px 12px;
      padding-top: 10px;

      @media (min-width: 768px) {
        padding: 24px 32px;
        margin: 0 -32px -24px -32px;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        gap: 16px;
      }

      .el-button {
        width: 100%;
        min-height: 44px;
        font-weight: 600;
        font-size: 15px;
        border-radius: 8px;
        transition: all 0.3s ease;

        @media (min-width: 768px) {
          width: auto;
          min-width: 140px;
        }

        &:not(.el-button--primary) {
          background: #f7fafc;
          border: 2px solid #e2e8f0;
          color: #4a5568;

          &:hover {
            background: #edf2f7;
            border-color: #cbd5e0;
            transform: translateY(-1px);
          }
        }

        &.el-button--primary {
          background: #001F5B;
          border: 1px solid #001F5B;
          color: white;

          &:hover {
            background: #001849;
            border-color: #001849;
            transform: translateY(-1px);
          }

          &:disabled {
            background: #9ca3af;
            border-color: #9ca3af;
            transform: none;
          }
        }
      }
    }
  }
}

// Additional mobile-specific improvements
@media (max-width: 767px) {
  .mt-10 {
    margin-top: 16px !important;
  }

  .mb--05 {
    margin-bottom: 8px !important;
  }

  .d-flex.flex-column.mt-05 {
    margin-top: 12px !important;

    > div {
      margin-bottom: 8px;
      line-height: 1.4;
    }
  }

  .fs-15 {
    font-size: 16px !important;
    font-weight: 600;
    margin-bottom: 12px !important;
  }

  .title {
    display: inline-block;
    min-width: 140px;
    font-weight: 600;
  }
}

// Registration Summary Card Styles
.registration-summary-card {
  margin-bottom: 20px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;

  .card-header-content {
    padding: 0;

    .registration-title {
      margin: 0;
      font-size: 18px;
      font-weight: 600;
      color: #001F5B;
    }
  }

  .registration-details {
    padding: 0;

    .detail-item {
      display: flex;
      margin-bottom: 12px;

      &:last-child {
        margin-bottom: 0;
      }

      .detail-label {
        font-weight: 600;
        color: #606266;
        min-width: 140px;
        font-size: 14px;
      }

      .detail-value {
        color: #303133;
        font-size: 14px;
        flex: 1;
      }
    }

    .family-members-section,
    .bulk-members-section {
      margin-top: 20px;

      .members-section-title {
        margin: 0 0 12px 0;
        font-size: 16px;
        font-weight: 600;
        color: #001F5B;
      }
    }
  }

  ::v-deep .el-card__header {
    background-color: #f8fafc;
    border-bottom: 1px solid #e2e8f0;
    padding: 16px;

    @media (max-width: 767px) {
      padding: 12px 16px;
    }
  }

  ::v-deep .el-card__body {
    padding: 16px;

    @media (max-width: 767px) {
      padding: 16px;
    }
  }

  @media (max-width: 767px) {
    margin-bottom: 16px;

    .registration-details {
      .detail-item {
        flex-direction: column;
        margin-bottom: 16px;

        .detail-label {
          min-width: auto;
          margin-bottom: 4px;
          font-weight: 600;
        }

        .detail-value {
          margin-left: 0;
        }
      }
    }
  }
}

// Registration Actions (Remove/Edit Buttons)
.registration-actions {
  display: flex;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #e2e8f0;

  .action-btn {
    flex: 0 1 180px;
    min-width: 120px;
    height: 40px;
    font-weight: 600;
    border-radius: 6px;
    transition: all 0.3s ease;

    &.remove-btn {
      background-color: #dc3545;
      border-color: #dc3545;

      &:hover {
        background-color: #c82333;
        border-color: #bd2130;
        transform: translateY(-1px);
      }
    }

    &.edit-btn {
      background-color: #001F5B;
      border-color: #001F5B;

      &:hover {
        background-color: #001849;
        border-color: #001849;
        transform: translateY(-1px);
      }
    }
  }

  @media (max-width: 767px) {
    width: 100%;
    gap: 10px;
    justify-content: space-between;

    .action-btn {
      flex: 1 1 calc(50% - 10px);
      min-width: auto;
    }
  }
}

// Mobile-first responsive design implemented above
</style>
